// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Styles specific to OutgoingApprovalsComponent */
.big-box {
  border: 2px solid #333;
  padding: 20px;
  background-color: #f0f0f0;
  border-radius: 10px;
  box-shadow: 2px 2px 5px #888;
  text-align: center;
}

/* Filters and actions styling for Transfered Content Approvals */
.filter-section {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #e6e6e6;
  background: #f9fbfe;
}

.filter-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-control label {
  font-size: 13px;
  color: #3c4858;
  font-weight: 600;
}

.filter-control select,
.filter-control input[type=date] {
  height: 36px;
  padding: 6px 10px;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  background: #fff;
  color: #263238;
}

.custom-date-range {
  display: flex;
  align-items: center;
  gap: 16px;
}

.actions-cell {
  white-space: nowrap;
}
.actions-cell .btn,
.actions-cell .badge,
.actions-cell mat-icon {
  vertical-align: middle;
}

.action-btn {
  min-width: 88px;
  margin-right: 8px;
  border-radius: 6px;
  text-transform: capitalize;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}

.action-btn--approve {
  background-color: #2e7d32;
  border-color: #2e7d32;
}

.action-btn--reject {
  background-color: #c62828;
  border-color: #c62828;
}

.action-btn--cancel {
  background-color: #f9a825;
  border-color: #f9a825;
  color: #1a1a1a;
}

/* Make followers-tag cards look exactly like dashboard cards */
.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
  width: 100%;
  flex-wrap: wrap;
}

.followers-tag .box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
  gap: 12px;
}

.followers-tag .box .icon {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.followers-tag .box .ico-box {
  width: 40px;
  height: 40px;
  background: transparent; /* remove bg */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
}

.followers-tag .box .card-icon {
  font-size: 24px;
  color: #5ea1d8;
}

.followers-tag .box .text {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
  justify-content: center;
  gap: 2px;
}

.followers-tag .box .text .count {
  background: white !important;
  box-shadow: none !important;
}

.followers-tag .box .text .count b {
  font-size: 24px; /* increased for better prominence */
  font-weight: 700 !important; /* bold like dashboard */
  color: #333;
  display: block;
  line-height: 1.2;
}

.followers-tag .box .text p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.2;
  text-align: left;
}

body {
  overflow-x: hidden;
}

.logo {
  width: 100px;
  margin-right: 100px;
}

.top-menu-wrap {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}

.user-name {
  display: flex;
  align-items: center;
}

.user-details {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.user-name p {
  display: flex;
  align-items: center;
}

.user-name span {
  width: 40px;
  height: 40px;
  background: red;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}

.dashbored-wrap {
  display: flex;
  width: 100%;
  height: 100vh;
  background: var(--fc-bg, #fff);
  /* background: red; */
}

.top-menu-wrap {
  width: 100%;
  height: 100px;
  background: #fff;
}

.dash-details {
  width: 100%;
  display: flex;
  max-height: 100vh;
  /* background: green; */
}

.detail-list {
  max-width: 250px;
  width: 100%;
  padding: 20px 10px;
  background-color: #efeeee;
  color: #212529;
  position: fixed;
  top: calc(var(--app-header) + 24px);
  height: calc(100vh - 120px);
}

ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

p {
  margin-bottom: 10px;
}

ul li {
  margin-bottom: 10px;
  height: 40px;
  padding: 0px 10px;
  position: relative;
  z-index: 1;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
}

ul li:before {
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0%;
  z-index: -1;
}

ul li:hover {
  color: #000;
}

ul li:hover:before {
  /* background: #fff;
      color: #212529; */
  width: 100%;
}

.table-bordered {
  border: 0px;
}

.detail-description {
  /* width: 100%; */
  height: 100%;
  padding: 0px;
  width: calc(100% - 250px);
  height: 100%;
  padding: 0px;
  width: 100%;
  left: 270px;
  top: calc(var(--app-header) + 24px);
  /* background: purple; */
}

.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
}

h3 {
  position: relative;
  z-index: 3;
  color: #fff;
  font-weight: normal;
}

.com-record {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
  box-shadow: none !important;
  border: none !important;
}
.com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}

.com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  /* background: gray; */
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
}

.ico-box {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  margin-bottom: 8px;
}

.ico-box b {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: center;
  line-height: 1;
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Arial", sans-serif;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.table-wrap {
  padding: 30px;
  /* width:calc(100% - 76px); */
}

.box {
  width: auto;
  padding: 15px 20px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: none !important;
  background-color: #fff !important;
}

.box:hover {
  transform: translateY(-2px);
  box-shadow: 2px 4px 30px rgba(0, 0, 0, 0.2);
}

.box:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #5ea1d8, #4a90da);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.box:hover:before {
  opacity: 1;
}

.filter-ico li {
  width: 40px;
}

.filter-ico li i {
  color: #000;
}

.text {
  padding: 0;
  text-align: center;
  width: 100%;
}

.text p {
  margin: 0;
  font-size: 12px;
  color: #666;
  text-align: center;
  line-height: 1.2;
  font-weight: 500;
}

.table-parent {
  overflow-x: scroll;
  margin-top: -8px;
  overflow-y: auto;
}

/* Scoped table styling */
.table-card {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(28, 28, 30, 0.06);
  padding: 0;
  margin-top: 5vh;
}

.fc-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.fc-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-align: left;
  padding: 16px;
  border-bottom: 2px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
}

.fc-table thead th:first-child {
  border-top-left-radius: 10px;
}

.fc-table thead th:last-child {
  border-top-right-radius: 10px;
  border-right: none;
}

.fc-table tbody tr {
  transition: background-color 0.15s ease-in-out;
}

.fc-table tbody tr:nth-child(even) td {
  background-color: #f7fbff;
}

.fc-table tbody tr:hover td {
  background-color: #f0f8ff;
  color: #2c3e50;
  font-weight: 500;
  border-color: #bbdefb;
  transition: all 0.3s ease;
}

.fc-table tbody td {
  padding: 12px 14px;
  border-top: 1px solid #e6eef4;
  border-right: 1px solid #eef3f7;
}

.fc-table tbody td:last-child {
  border-right: none;
}

.fc-table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

.fc-table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

table {
  margin-bottom: 20px;
  border-collapse: collapse;
  width: 100%;
  background: white;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

th,
td {
  border: none;
  color: #333;
  padding: 16px;
  min-width: 100px;
  font-family: "Raleway";
  vertical-align: middle;
}

th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
  padding: 16px;
  border-bottom: 2px solid #e0e0e0;
}

td {
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}

td[scope=row] {
  position: relative;
}

.inner {
  width: 100%;
  margin-bottom: 0px;
}
.inner td {
  padding: 5px;
  border: 0px;
}
.inner td:first-child {
  width: 30px;
}

tbody tr {
  cursor: pointer;
  transition: background-color 0.2s;
}
tbody tr:hover {
  background-color: #f9f9f9;
}
tbody tr:hover td {
  color: #333;
}
tbody tr:last-child td {
  border-bottom: none;
}

.filter {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  border: 1px solid #ddd;
  border-bottom: 0px;
  padding: 10px 10px;
}

.filter-title {
  flex: 1;
}

.filter ul {
  display: flex;
}

.filter-bar {
  display: flex;
}

.search-container {
  position: relative;
}

.search-input {
  width: 400px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}

.search-input + i {
  position: absolute;
  right: 20px;
  top: 37%;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.chekbox-image {
  display: flex;
}
.chekbox-image td:first-child {
  width: unset;
  flex: 1;
  min-width: 150px;
  display: flex;
  align-items: flex-start;
}
.chekbox-image td:first-child span {
  padding-left: 13px;
}
.chekbox-image td:last-child {
  min-width: unset;
  width: 40px;
  display: flex;
  align-items: flex-start;
}

.image-sec img {
  max-width: 100%;
  max-height: 80px;
  width: 100%;
  object-fit: cover;
}

.btn-add-page {
  width: 75%;
  display: block;
  margin: 5px auto;
}

.square_btn {
  text-align: center;
  padding: 7px 20px;
  border-radius: 25px;
  border: 1px solid #5ea1d8;
  text-decoration: none;
  color: #5ea1d8;
  background-image: linear-gradient(45deg, white 0%, white 100%);
  transition: 0.4s;
  font-family: "Raleway";
}

.square_btn:hover {
  color: white;
  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);
}

.square_btn {
  font-family: "Raleway";
  color: #5ea1d8;
}
.square_btn:hover {
  color: #fff;
}

.bundle-dialog {
  min-width: 320px;
  max-width: 420px;
  padding: 8px 0;
}
.bundle-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  position: relative;
}
.bundle-dialog .dialog-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  gap: 8px;
  align-items: center;
  color: #333;
  flex: 1;
  margin-left: 55px;
  text-align: center;
}
.bundle-dialog .dialog-header .close-btn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background-color 0.2s;
}
.bundle-dialog .dialog-header .close-btn:hover {
  background-color: #f0f0f0;
}
.bundle-dialog .dialog-header .close-icon {
  font-size: 24px;
  font-weight: bold;
  color: #666;
  line-height: 1;
}
.bundle-dialog .dialog-content {
  padding: 16px 20px;
}
.bundle-dialog .dialog-content .subtitle {
  margin: 0 0 12px 0;
  color: #666;
  font-size: 13px;
}

.mobile-design {
  display: none;
  padding: 20px 10px;
  background: lightblue;
}
.mobile-design .tile {
  background: #fff;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}
.mobile-design .tile .main-title {
  display: flex;
  align-items: center;
  background: #5ea1d8;
  padding: 12px;
  margin: -15px -15px 15px -15px;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  transition: background-color 0.2s;
}
.mobile-design .tile .main-title:hover {
  background: #4a8bc7;
}
.mobile-design .tile .main-title h3 {
  margin: 0;
  color: #fff !important;
  font-size: 16px;
  font-weight: 600;
}
.mobile-design .tile .first-tile {
  margin-bottom: 15px;
}
.mobile-design .tile .first-tile .content-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.mobile-design .tile .first-tile .content-info .content-type {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
}
.mobile-design .tile .first-tile .content-info .content-type mat-icon {
  font-size: 18px;
  margin-right: 5px;
  color: #5ea1d8;
}
.mobile-design .tile .first-tile .content-info .status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.mobile-design .tile .first-tile .content-info .status-badge.status-pending {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}
.mobile-design .tile .first-tile .content-info .status-badge.status-approved {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.mobile-design .tile .first-tile .content-info .status-badge.status-rejected {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
.mobile-design .tile .first-tile .content-info .status-badge.status-reworkrequested {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}
.mobile-design .tile .first-tile .content-info .status-badge.status-cancelled {
  background: #e2e3e5;
  color: #383d41;
  border: 1px solid #d6d8db;
}
.mobile-design .tile .common-tile {
  display: flex;
  margin-bottom: 12px;
}
.mobile-design .tile .common-tile .title-tile {
  flex: 1;
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mobile-design .tile .common-tile .title-tile p {
  margin: 0;
  color: #666;
  font-size: 12px;
  line-height: 1.3;
}
.mobile-design .tile .common-tile .title-tile p.bold {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}
.mobile-design .tile .actions-section {
  border-top: 1px solid #e9ecef;
  padding-top: 15px;
  margin-top: 15px;
}
.mobile-design .tile .actions-section .processing-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
  font-size: 12px;
  color: #666;
}
.mobile-design .tile .actions-section .processing-indicator mat-spinner {
  margin-right: 8px;
}
.mobile-design .tile .actions-section .mobile-btn {
  width: 100%;
  margin-bottom: 8px;
  padding: 8px 12px;
  font-size: 13px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}
.mobile-design .tile .actions-section .mobile-btn:last-child {
  margin-bottom: 0;
}
.mobile-design .tile .actions-section .mobile-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.mobile-design .tile .actions-section .badge {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: center;
  width: 100%;
  margin-bottom: 8px;
}
.mobile-design .tile .actions-section .badge.badge-success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.mobile-design .tile .actions-section .badge.badge-danger {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
.mobile-design .tile .actions-section .badge.badge-secondary {
  background: #e2e3e5;
  color: #383d41;
  border: 1px solid #d6d8db;
}
.mobile-design .tile .actions-section .badge.badge-info {
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
}
.mobile-design .no-results {
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-size: 16px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .followers-tag {
    flex-wrap: wrap;
    width: 100%;
  }
  .dashbored-wrap .followers-tag .box {
    margin: 0;
    width: calc(50% - 10px);
    min-width: 250px;
  }
  .dashbored-wrap .followers-tag .box .text {
    flex: 1;
  }
  .dashbored-wrap .com-record {
    padding: 20px;
  }
  .dashbored-wrap .com-record:after {
    height: 140px;
  }
  .dashbored-wrap .filter {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .dashbored-wrap .search-container .search-input {
    width: 100%;
    max-width: 400px;
  }
  .dashbored-wrap .top-menu-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .dashbored-wrap .table-wrap {
    top: unset;
    position: relative;
    padding: 20px;
  }
  .dashbored-wrap .table-wrap .table-parent {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .dashbored-wrap .mobile-design {
    display: none;
  }
  table {
    min-width: 600px;
  }
  table th,
  table td {
    padding: 12px 8px;
    font-size: 14px;
    min-width: 80px;
  }
  table th {
    font-size: 13px;
    font-weight: 600;
  }
  .followers-tag .box {
    padding: 15px;
  }
  .followers-tag .box .text {
    font-size: 14px;
  }
}
@media (min-width: 1024px) and (max-width: 1199px) {
  .dashbored-wrap .followers-tag .box {
    width: calc(33.333% - 14px);
    min-width: 200px;
  }
  .dashbored-wrap .table-wrap .table-parent {
    overflow-x: auto;
  }
  table th,
  table td {
    padding: 10px 6px;
    font-size: 13px;
    min-width: 70px;
  }
}
@media (max-width: 992px) {
  /* Hide all table elements on mobile */
  .table-wrap,
  .table-parent,
  .table-card,
  .fc-table,
  table {
    display: none !important;
  }
  .mobile-design {
    display: block;
    /* Re-enable table UI inside mobile section */
  }
  .mobile-design .table-parent {
    display: block !important;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .mobile-design .table-card {
    display: block !important;
  }
  .mobile-design .fc-table,
  .mobile-design table {
    display: table !important;
    width: 100%;
  }
  .followers-tag {
    flex-wrap: wrap;
  }
  .followers-tag .box {
    margin: 10px;
    width: 100%;
  }
  .followers-tag .box .text {
    flex: 1;
  }
  .com-record {
    padding: 15px;
  }
  .com-record:after {
    height: 130px;
  }
}
@media (max-width: 768px) {
  .mobile-design {
    padding: 5px !important;
  }
  .mobile-design .tile {
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #ffffff;
    margin-bottom: 12px;
  }
  .mobile-design .tile .main-title {
    margin: -12px -12px 12px -12px;
    padding: 10px;
  }
  .mobile-design .tile .main-title h3 {
    font-size: 15px;
  }
  .mobile-design .tile .common-tile {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .mobile-design .tile .common-tile .title-tile {
    width: 50%;
    margin-bottom: 8px;
    display: block;
  }
  .mobile-design .tile .common-tile .title-tile p {
    display: block;
  }
  .mobile-design .tile .common-tile .title-tile .bold {
    display: block;
    margin-top: 2px;
  }
}
@media (max-width: 480px) {
  .mobile-design {
    padding: 10px 5px;
  }
  .mobile-design .tile {
    padding: 10px;
  }
  .mobile-design .tile .main-title {
    margin: -10px -10px 10px -10px;
    padding: 8px;
  }
  .mobile-design .tile .main-title h3 {
    font-size: 14px;
  }
  .mobile-design .tile .actions-section .mobile-btn {
    font-size: 12px;
    padding: 6px 10px;
  }
}
.pie-chart-canvas {
  width: 400px;
  height: 400px;
}

.mat-mdc-tab-list {
  margin-bottom: 10px;
}

/* Assuming each chart component has a class name of 'chart-container' */
.row {
  grid-template-columns: auto auto; /* Use flexbox to align items in a row */
  overflow-x: hidden !important;
}

.chart-container {
  margin: 15px;
  height: 25vh;
  width: 50vh;
  flex: 1;
}

/* new setting common design starts here*/
.setting-dashboard {
  padding: 0;
  height: auto;
  position: relative;
  margin-top: 0;
  background: var(--fc-bg, #fff);
}

.dashbored-wrap {
  margin-top: 0;
}

.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}

.setting-dashboard .left-user {
  background: #5ea1d8;
  position: relative;
  padding: 0 0 0 30px;
  position: fixed;
  top: 120px;
  height: calc(100vh - 100px);
  z-index: 3;
}

.collapse-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  background: #5ea1d8;
  border-radius: 50%;
  right: -12.5px;
  top: 26px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transform: rotate(180deg);
}

.setting-dashboard .left-user .dash-title {
  position: unset;
  width: 100%;
}

.setting-dashboard .dash-title {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 2;
  top: 120px;
}

.setting-dashboard .dash-title h6,
.setting-dashboard .dash-title .h6 {
  display: flex;
  align-items: center;
  font-weight: 500 !important;
  color: #fff !important;
}

.setting-dashboard .dash-title h6 span,
.setting-dashboard .dash-title .h6 span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

.setting-dashboard.search-add .dash-elemenet {
  height: calc(100vh - 180px);
}
.setting-dashboard.search-add .dash-elemenet ul {
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style-type: none;
}
.setting-dashboard.search-add .dash-elemenet ul li {
  height: 40px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.5s linear;
  padding-left: 10px;
}
.setting-dashboard.search-add .dash-elemenet ul li:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #1d67a3;
  transition: all 0.5s linear;
  width: 0;
  z-index: -1;
}
.setting-dashboard.search-add .dash-elemenet ul li:hover:after, .setting-dashboard.search-add .dash-elemenet ul li:active:after, .setting-dashboard.search-add .dash-elemenet ul li:focus:after {
  content: "";
  width: 100%;
  left: 0;
  transition: all 0.5s linear;
}

.setting-dashboard .dash-elemenet {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}

.setting-dashboard .dash-elemenet > div {
  width: 100%;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
  transition: all 0.5slinear;
  position: relative;
  padding-bottom: 0;
  z-index: 2;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.left-user .selected-item {
  background: #1d67a3 !important;
  padding-left: 10px;
}

.setting-dashboard .left-user .dash-elemenet > div span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

/*right section*/
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important; /* match landing page */
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}

.scroll-div .dash-text {
  padding: 10px 15px 0; /* match landing page padding */
}

.mat-mdc-tab-group {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.setting-dashboard .dash-elemenet > div:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #6322b2;
  transition: width 0.5sease 0s, left 0.5sease 0s;
  width: 0;
  z-index: -1;
}

.setting-dashboard .dash-elemenet > div span:last-child {
  font-size: 12px !important;
}

@media (max-width: 767px) {
  .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .mob-menu {
    background: #5d9fd5 !important;
    position: sticky;
    top: var(--app-header, 56px);
    z-index: 1500;
    width: 100%;
    display: block !important;
  }
  .navbar {
    justify-content: flex-start;
    margin-bottom: 0px;
  }
  .mob-menu button {
    background: #5d9fd5 !important;
    margin-bottom: 0 !important;
    color: #fff;
    font-size: 14px;
    padding: 10px 5px;
    text-transform: capitalize;
    border: 1px solid #fff !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center;
  }
}
.setting-dashboard {
  padding: 0;
  position: relative;
  margin-top: 0;
  background: #fff;
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}
.setting-dashboard .left-user {
  background: #5ea1d8;
  position: relative;
  padding: 0 0 0 30px;
  position: fixed;
  top: calc(var(--app-header) + 24px);
  height: calc(100vh - 100px);
  z-index: 3;
}
.setting-dashboard .left-user .collapse-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  background: #5ea1d8;
  border-radius: 50%;
  right: -12.5px;
  top: 26px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transform: rotate(180deg);
}
.setting-dashboard .left-user .dash-elemenet {
  height: calc(100vh - 180px);
}
.setting-dashboard .left-user .dash-elemenet ul {
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style-type: none;
}
.setting-dashboard .left-user .dash-elemenet ul li {
  height: 40px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.5s linear;
  padding-left: 10px;
}
.setting-dashboard .left-user .dash-elemenet ul li:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #1d67a3;
  transition: all 0.5s linear;
  width: 0;
  z-index: -1;
}
.setting-dashboard .left-user .dash-elemenet ul li:hover:after, .setting-dashboard .left-user .dash-elemenet ul li:active:after, .setting-dashboard .left-user .dash-elemenet ul li:focus:after {
  content: "";
  width: 100%;
  left: 0;
  transition: all 0.5s linear;
}

.dashbored-wrap {
  margin-top: 0;
}

.setting-dashboard .left-user .dash-title {
  position: unset;
  width: 100%;
}

.setting-dashboard .dash-title {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 2;
  top: calc(var(--app-header) + 24px);
}

.setting-dashboard .dash-title h6,
.setting-dashboard .dash-title .h6 {
  display: flex;
  align-items: center;
  font-weight: 500 !important;
  color: #fff !important;
}

.setting-dashboard .dash-title h6 span,
.setting-dashboard .dash-title .h6 span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

.setting-dashboard .dash-elemenet {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}

.setting-dashboard .dash-elemenet > div {
  width: 100%;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
  transition: all 0.5slinear;
  position: relative;
  padding-bottom: 0;
  z-index: 2;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.left-user .selected-item {
  background: #1d67a3 !important;
  padding-left: 10px;
}

.setting-dashboard .left-user .dash-elemenet > div span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

/*right section*/
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: var(--app-header) !important; /* match landing page */
  margin-top: 0 !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 10px 15px 0; /* match landing page padding */
}

.mat-mdc-tab-group {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.setting-dashboard .dash-elemenet > div:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #6322b2;
  transition: width 0.5sease 0s, left 0.5sease 0s;
  width: 0;
  z-index: -1;
}

.setting-dashboard .dash-elemenet > div span:last-child {
  font-size: 12px !important;
}

@media (max-width: 767px) {
  .scroll-div {
    margin-top: 0 !important;
    padding-top: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 0 !important;
  }
  .mob-menu {
    background: #5d9fd5 !important;
    position: sticky;
    top: var(--app-header, 56px);
    z-index: 1500;
    width: 100%;
    display: block !important;
  }
  .navbar {
    justify-content: flex-start;
    margin-bottom: 0px;
  }
  .mob-menu button {
    background: #5d9fd5 !important;
    margin-bottom: 0 !important;
    color: #fff;
    font-size: 14px;
    padding: 10px 5px;
    text-transform: capitalize;
    border: 1px solid #fff !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center;
  }
  .setting-dashboard .left-user {
    width: 59vw;
    position: fixed;
    top: calc(var(--app-header, 56px) + 48px);
    height: calc(100vh - (var(--app-header, 56px) + 48px));
    padding-left: 10px;
    left: -59vw;
    transition: left 0.5s linear;
    display: block !important;
    z-index: 1600;
  }
  .setting-dashboard .show-menu .left-user {
    left: 0px;
    transition: left 0.5s linear;
  }
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .table-wrap {
    padding: 0px;
  }
  .setting-dashboard .submission-field .hamburger .dash-title {
    width: 100%;
    top: calc(var(--app-header, 56px) + 48px);
    height: 40px;
  }
  .setting-dashboard .left-user .dash-title {
    display: none;
  }
  .setting-dashboard .left-user .collapse-btn {
    display: none;
  }
  .dashbored-wrap {
    margin-top: 17px !important;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px;
  }
  .dashbored-wrap .com-record:after {
    height: 133px;
  }
  .followers-tag .box {
    margin: 0px 0px 8px 0px;
    width: 100%;
    min-width: 200px;
    flex: 1;
  }
  .followers-tag .box .ico-box {
    width: 35px;
    height: 35px;
    margin-bottom: 6px;
    border-radius: 6px;
  }
  .followers-tag .box .ico-box b {
    font-size: 16px;
  }
  .followers-tag .box .text p {
    font-size: 11px;
    line-height: 1.1;
  }
}
.cursor {
  cursor: pointer;
}

.skeleton-stats-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  width: 100%;
}

.skeleton-box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
  min-width: 150px;
  flex: 1;
}

.skeleton-table-container {
  margin: 16px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  width: 100%;
  min-height: 300px;
  overflow-x: auto;
}

.skeleton-mobile-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 16px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  width: 100%;
  min-height: 400px;
}

.skeleton-text {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  height: 16px;
  margin: 4px 0;
}
.skeleton-text.skeleton-title {
  height: 20px;
  width: 80%;
}
.skeleton-text.skeleton-bold {
  height: 18px;
  width: 60%;
}

.skeleton-checkbox {
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 3px;
  margin-right: 10px;
}

.skeleton-icon {
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 50%;
}

.skeleton-image {
  width: 100%;
  height: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  object-fit: cover;
}

.skeleton-price {
  width: 60px;
  height: 20px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite;
  border-radius: 4px;
  margin-left: 10px;
}

.skeleton-analytics {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
}

.skeleton-tile {
  background: #fff;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 12px;
  width: 100%;
}
.skeleton-tile .main-title {
  display: flex;
  align-items: center;
  background: #5ea1d8;
  padding: 10px;
  margin-bottom: 10px;
}
.skeleton-tile .main-title .skeleton-title {
  height: 24px;
  width: 70%;
}
.skeleton-tile .first-tile div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.skeleton-tile .first-tile .img {
  display: flex;
  align-items: flex-start;
}
.skeleton-tile .first-tile .img .bundle {
  width: 30px;
  margin-right: 10px;
  height: 30px;
}
.skeleton-tile .common-tile {
  display: flex;
}
.skeleton-tile .common-tile .title-tile {
  flex: 1;
  padding: 3px;
}

@keyframes skeleton-loading {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@media (max-width: 768px) {
  .skeleton-stats-container {
    grid-template-columns: 1fr;
    gap: 12px;
    padding: 12px;
    width: 100%;
    min-height: 150px;
  }
  .skeleton-table-container {
    padding: 12px;
    margin: 12px 0;
    width: 100%;
    min-height: 250px;
    display: block;
  }
  .skeleton-mobile-container {
    padding: 12px;
    margin: 12px 0;
    width: 100%;
    min-height: 300px;
    display: flex;
  }
}
@media (max-width: 480px) {
  .skeleton-stats-container {
    padding: 8px;
    gap: 8px;
    min-height: 120px;
  }
  .skeleton-table-container,
  .skeleton-mobile-container {
    padding: 8px;
    margin: 8px 0;
  }
  .skeleton-table-container {
    min-height: 200px;
  }
  .skeleton-mobile-container {
    min-height: 250px;
  }
}
/* Desktop followers-tag cards to match dashboard */
.dashbored-wrap .followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
}
.dashbored-wrap .followers-tag .box {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  box-shadow: none;
  background-color: #fff;
  width: auto;
  padding: 5px 10px; /* desktop card padding */
  margin-right: 20px; /* desktop spacing */
  border: 1px solid #ddd;
  border-radius: 10px;
  min-width: 200px;
}
.dashbored-wrap .followers-tag .box .ico-box {
  background: transparent;
  border-radius: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  box-shadow: none !important;
}
.dashbored-wrap .followers-tag .box .text {
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
  justify-content: center;
  gap: 2px;
}
.dashbored-wrap .followers-tag .box .text .count {
  background: transparent !important;
  box-shadow: none !important;
}
.dashbored-wrap .followers-tag .box .text .count b {
  font-size: 24px;
  font-weight: 700 !important;
  color: #333;
  display: block;
  line-height: 1.2;
}
.dashbored-wrap .followers-tag .box .text p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.2;
}

/* Mobile: match dashboard spacing */
@media (max-width: 992px) {
  .dashbored-wrap .followers-tag {
    flex-wrap: wrap;
    margin-top: 10px;
    gap: 16px;
  }
  .dashbored-wrap .followers-tag .box {
    margin-bottom: -8px;
    margin-right: 0;
    width: 100%;
    min-width: 200px;
    flex: 1;
  }
  .dashbored-wrap .com-record {
    padding: 7px !important; /* consistent container padding */
  }
  .dashbored-wrap .com-record:after {
    height: 130px;
  }
}
:host-context(body.theme-dark) .dashbored-wrap,
:host-context(body.theme-dark) .setting-dashboard,
:host-context(body.theme-dark) .scroll-div,
:host-context(body.theme-dark) .com-record,
:host-context(body.theme-dark) .table-wrap,
:host-context(body.theme-dark) .filter,
:host-context(body.theme-dark) .filter-section,
:host-context(body.theme-dark) .search-input,
:host-context(body.theme-dark) .detail-list {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .filter-control label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .filter-control select,
:host-context(body.theme-dark) .filter-control input[type=date] {
  background: #0f172a !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .table-card {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .fc-table thead th {
  background: #0f172a !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .fc-table tbody td {
  border-color: rgba(148, 163, 184, 0.15) !important;
}
:host-context(body.theme-dark) .fc-table tbody tr:nth-child(even) td {
  background-color: #1a2030 !important;
}
:host-context(body.theme-dark) .fc-table tbody tr:hover td {
  background-color: #1f2937 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) table, :host-context(body.theme-dark) thead, :host-context(body.theme-dark) tbody, :host-context(body.theme-dark) tr, :host-context(body.theme-dark) td {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) th {
  background: #0f172a !important;
  background-color: #0f172a !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) tbody tr:hover {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .box, :host-context(body.theme-dark) .followers-tag .box {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .followers-tag .box .text .count {
  background: transparent !important;
}
:host-context(body.theme-dark) .followers-tag .box .text .count b {
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .followers-tag .box .text p {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) p, :host-context(body.theme-dark) span:not(.material-icons):not(.status-badge-modern):not([class*=badge]):not([class*=status-]), :host-context(body.theme-dark) label, :host-context(body.theme-dark) li, :host-context(body.theme-dark) h1, :host-context(body.theme-dark) h2, :host-context(body.theme-dark) h3, :host-context(body.theme-dark) h4, :host-context(body.theme-dark) h5, :host-context(body.theme-dark) h6, :host-context(body.theme-dark) i, :host-context(body.theme-dark) b {
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .mobile-design {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .mobile-design .tile {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .mobile-design .tile .actions-section {
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .mobile-design .tile .actions-section .processing-indicator {
  background: #0f172a !important;
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .mobile-design .no-results {
  background: #1f2937 !important;
  color: #94a3b8 !important;
  border-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .skeleton-box,
:host-context(body.theme-dark) .skeleton-tile,
:host-context(body.theme-dark) .skeleton-table-container,
:host-context(body.theme-dark) .skeleton-mobile-container {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .skeleton-text,
:host-context(body.theme-dark) .skeleton-checkbox,
:host-context(body.theme-dark) .skeleton-icon,
:host-context(body.theme-dark) .skeleton-image,
:host-context(body.theme-dark) .skeleton-price {
  background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%) !important;
  background-size: 200% 100% !important;
  animation: skeleton-loading 1.5s infinite !important;
}

body.theme-dark .dashbored-wrap,
body.theme-dark .setting-dashboard {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .top-menu-wrap,
body.theme-dark .dashbored-wrap .box,
body.theme-dark .dashbored-wrap .card,
body.theme-dark .dashbored-wrap .mat-mdc-card,
body.theme-dark .dashbored-wrap .tile,
body.theme-dark .dashbored-wrap .com-record,
body.theme-dark .dashbored-wrap .table-wrap,
body.theme-dark .dashbored-wrap .detail-list,
body.theme-dark .dashbored-wrap .filter,
body.theme-dark .dashbored-wrap .search-input,
body.theme-dark .dashbored-wrap .tab-content,
body.theme-dark .dashbored-wrap .followers-tag .box {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap table,
body.theme-dark .dashbored-wrap thead,
body.theme-dark .dashbored-wrap tbody,
body.theme-dark .dashbored-wrap tr,
body.theme-dark .dashbored-wrap td {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap th {
  background: var(--fc-bg-head) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap tbody tr:hover {
  background: var(--fc-bg-hover) !important;
}

body.theme-dark .dashbored-wrap input,
body.theme-dark .dashbored-wrap select,
body.theme-dark .dashbored-wrap textarea {
  background: #0f172a !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap .mobile-design {
  background: var(--fc-bg) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap .mobile-design .tile {
  background: var(--fc-bg2) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .dashbored-wrap [class*=skeleton-] {
  background: var(--fc-skel) !important;
  color: transparent !important;
}

body.theme-dark .dashbored-wrap p,
body.theme-dark .dashbored-wrap label,
body.theme-dark .dashbored-wrap li,
body.theme-dark .dashbored-wrap h1,
body.theme-dark .dashbored-wrap h2,
body.theme-dark .dashbored-wrap h3,
body.theme-dark .dashbored-wrap h4,
body.theme-dark .dashbored-wrap h5,
body.theme-dark .dashbored-wrap h6 {
  color: var(--fc-fg) !important;
}

body.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=status]) {
  color: var(--fc-fg) !important;
}

/* ── Direct body.theme-dark additions (outgoing-transfer-approvals page) ── */
body.theme-dark .big-box {
  background-color: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .filter-section {
  background: var(--fc-bg2) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .filter-control label {
  color: #94a3b8 !important;
}

body.theme-dark .filter-control select,
body.theme-dark .filter-control input[type=date] {
  background: #0f172a !important;
  color: #e5e7eb !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}

body.theme-dark .table-card {
  background: var(--fc-bg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .fc-table thead th {
  background: var(--fc-bg-head) !important;
  color: var(--fc-fg) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .fc-table tbody td {
  border-color: var(--fc-border) !important;
}

body.theme-dark .fc-table tbody tr:nth-child(even) td {
  background-color: #1a2030 !important;
}

body.theme-dark .fc-table tbody tr:hover td {
  background-color: var(--fc-bg-hover) !important;
  color: var(--fc-fg) !important;
}

body.theme-dark .followers-tag .box .text .count {
  background: transparent !important;
}

body.theme-dark .followers-tag .box .text .count b {
  color: #f1f5f9 !important;
}

body.theme-dark .followers-tag .box .text p {
  color: #94a3b8 !important;
}

body.theme-dark .skeleton-box,
body.theme-dark .skeleton-tile {
  background: var(--fc-bg2) !important;
  border-color: var(--fc-border) !important;
}

body.theme-dark .skeleton-table-container,
body.theme-dark .skeleton-mobile-container {
  background: var(--fc-bg2) !important;
}

body.theme-dark .square_btn {
  background-image: linear-gradient(45deg, #1f2937 0%, #1f2937 100%) !important;
  color: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
}

body.theme-dark .bundle-dialog .dialog-header {
  border-color: rgba(148, 163, 184, 0.2) !important;
}

body.theme-dark .bundle-dialog .dialog-header h2 {
  color: var(--fc-fg) !important;
}

body.theme-dark .bundle-dialog .dialog-header .close-icon {
  color: #94a3b8 !important;
}

body.theme-dark .bundle-dialog .dialog-content .subtitle {
  color: #94a3b8 !important;
}

body.theme-dark .no-results {
  background: var(--fc-bg2) !important;
  color: #94a3b8 !important;
  border-color: var(--fc-border) !important;
}

/* ── Dark scrollbars and overflow area fix ── */
body.theme-dark .table-parent {
  background: #1f2937 !important;
  background-color: #1f2937 !important;
}

body.theme-dark .table-parent::-webkit-scrollbar,
body.theme-dark .table-card::-webkit-scrollbar {
  background: #111827;
  width: 6px;
  height: 6px;
}

body.theme-dark .table-parent::-webkit-scrollbar-track,
body.theme-dark .table-card::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb,
body.theme-dark .table-card::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 4px;
}

body.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,
body.theme-dark .table-card::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

body.theme-dark .table-parent::-webkit-scrollbar-corner,
body.theme-dark .table-card::-webkit-scrollbar-corner {
  background: #111827;
}

/* ── Status badge dark mode overrides ── */
body.theme-dark .status-badge.status-pending,
body.theme-dark .status-badge.status-reworkrequested {
  background: #451a03 !important;
  color: #fcd34d !important;
  border-color: rgba(252, 211, 77, 0.3) !important;
}

body.theme-dark .status-badge.status-approved {
  background: #052e16 !important;
  color: #86efac !important;
  border-color: rgba(134, 239, 172, 0.3) !important;
}

body.theme-dark .status-badge.status-rejected {
  background: #450a0a !important;
  color: #fca5a5 !important;
  border-color: rgba(252, 165, 165, 0.3) !important;
}

body.theme-dark .status-badge.status-cancelled {
  background: #1f2937 !important;
  color: #9ca3af !important;
  border-color: rgba(156, 163, 175, 0.3) !important;
}

/* ── Bootstrap-style badge dark mode overrides ── */
body.theme-dark .badge.badge-success {
  background: #052e16 !important;
  color: #86efac !important;
  border-color: rgba(134, 239, 172, 0.3) !important;
}

body.theme-dark .badge.badge-danger {
  background: #450a0a !important;
  color: #fca5a5 !important;
  border-color: rgba(252, 165, 165, 0.3) !important;
}

body.theme-dark .badge.badge-secondary {
  background: #1f2937 !important;
  color: #9ca3af !important;
  border-color: rgba(156, 163, 175, 0.3) !important;
}

body.theme-dark .badge.badge-info {
  background: #0c3443 !important;
  color: #67e8f9 !important;
  border-color: rgba(103, 232, 249, 0.3) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/transfered-content-approvals/outgoing-approvals.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,kDAAA;AAEA;EACE,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;AACF;;AAEA,iEAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,mBAAA;AACF;AACE;;;EAGE,sBAAA;AACJ;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,yCAAA;AAAF;;AAGA;EACE,yBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAAF;;AAEA,+DAAA;AACA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;EAEA,SAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,uBAAA,EAAA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,QAAA;AAAF;;AAGA;EACE,4BAAA;EACA,2BAAA;AAAF;;AAGA;EACE,eAAA,EAAA,oCAAA;EACA,2BAAA,EAAA,wBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EAEA,gBAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,uBAAA;AADF;;AAIA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,mCAAA;EACA,2BAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,mBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AAFF;;AAKA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,WAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE;uBAAA;EAEA,WAAA;AAFF;;AAKA;EACE,WAAA;AAFF;;AAKA;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EAEA,WAAA;EACA,mCAAA;EACA,wBAAA;AAHF;;AAMA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AAHF;;AAMA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,2BAAA;EACA,uBAAA;AAHF;AAOQ;EACE,6BAAA;AALV;;AAYA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AATF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,yCAAA;AAVF;;AAaA;EACE,aAAA;EACA,6BAAA;AAVF;;AAaA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oDAAA;EAGA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iCAAA;AAZF;;AAeA;EACE,2BAAA;EACA,2CAAA;AAZF;;AAeA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,oDAAA;EACA,UAAA;EACA,6BAAA;AAZF;;AAeA;EACE,UAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,WAAA;AAZF;;AAeA;EACE,UAAA;EACA,kBAAA;EACA,WAAA;AAZF;;AAeA;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,gBAAA;EAEA,gBAAA;AAbF;;AAgBA,yBAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,6CAAA;EACA,UAAA;EACA,eAAA;AAbF;;AAgBA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;EACA,+BAAA;AAbF;;AAgBA;EACE,4BAAA;AAbF;;AAgBA;EACE,6BAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,8CAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,6BAAA;EACA,+BAAA;AAbF;;AAgBA;EACE,kBAAA;AAbF;;AAgBA;EACE,+BAAA;AAbF;;AAgBA;EACE,gCAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAbF;;AAgBA;;EAEE,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,gCAAA;AAbF;;AAgBA;EACE,aAAA;EACA,gCAAA;EACA,sBAAA;AAbF;;AAgBA;EACE,kBAAA;AAbF;;AAgBA;EACE,WAAA;EACA,kBAAA;AAbF;AAeE;EACE,YAAA;EACA,WAAA;AAbJ;AAeI;EACE,WAAA;AAbN;;AAkBA;EACE,eAAA;EACA,iCAAA;AAfF;AAgBE;EACE,yBAAA;AAdJ;AAeI;EACE,WAAA;AAbN;AAgBE;EACE,mBAAA;AAdJ;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,OAAA;AAvBF;;AA0BA;EACE,aAAA;AAvBF;;AA0BA;EACE,aAAA;AAvBF;;AA0BA;EACE,kBAAA;AAvBF;;AA0BA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AAvBF;;AA0BA;EACE,aAAA;AAvBF;AA0BI;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAxBN;AA0BM;EACE,kBAAA;AAxBR;AA4BI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AA1BN;;AAgCE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA7BJ;;AAiCA;EACE,UAAA;EACA,cAAA;EACA,gBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EAEA,8DAAA;EAEA,gBAAA;EACA,sBAAA;AA/BF;;AAkCA;EACE,YAAA;EAEA,kEAAA;AA/BF;;AAkCA;EACE,sBAAA;EACA,cAAA;AA/BF;AAgCE;EACE,WAAA;AA9BJ;;AAkCA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AA/BF;AAiCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AA/BJ;AAiCI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;AA/BN;AAkCI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;AAhCN;AAkCM;EACE,yBAAA;AAhCR;AAoCI;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;AAlCN;AAsCE;EACE,kBAAA;AApCJ;AAsCI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;AApCN;;AA0CA;EACE,aAAA;EACA,kBAAA;EACA,qBAAA;AAvCF;AAyCE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,wCAAA;EACA,yBAAA;AAvCJ;AAyCI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,iCAAA;AAvCN;AAyCM;EACE,mBAAA;AAvCR;AA0CM;EACE,SAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAxCR;AA4CI;EACE,mBAAA;AA1CN;AA4CM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA1CR;AA4CQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA1CV;AA4CU;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AA1CZ;AA8CQ;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AA5CV;AA8CU;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA5CZ;AA+CU;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA7CZ;AAgDU;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA9CZ;AAiDU;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA/CZ;AAkDU;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAhDZ;AAsDI;EACE,aAAA;EACA,mBAAA;AApDN;AAsDM;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AApDR;AAsDQ;EACE,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AApDV;AAsDU;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AApDZ;AA0DI;EACE,6BAAA;EACA,iBAAA;EACA,gBAAA;AAxDN;AA0DM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAxDR;AA0DQ;EACE,iBAAA;AAxDV;AA4DM;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;AA1DR;AA4DQ;EACE,gBAAA;AA1DV;AA6DQ;EACE,2BAAA;EACA,wCAAA;AA3DV;AA+DM;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AA7DR;AA+DQ;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA7DV;AAgEQ;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA9DV;AAiEQ;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AA/DV;AAkEQ;EACE,mBAAA;EACA,cAAA;EACA,yBAAA;AAhEV;AAsEE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AApEJ;;AAyEA;EAEI;IACE,aAAA;EAvEJ;EAyEE;IACE,WAAA;IACA,SAAA;EAvEJ;EAyEE;IACE,eAAA;IACA,WAAA;EAvEJ;EAwEI;IACE,SAAA;IACA,uBAAA;IACA,gBAAA;EAtEN;EAuEM;IACE,OAAA;EArER;EAyEE;IACE,aAAA;EAvEJ;EAwEI;IACE,aAAA;EAtEN;EAyEE;IACE,aAAA;IACA,eAAA;IACA,SAAA;EAvEJ;EA0EI;IACE,WAAA;IACA,gBAAA;EAxEN;EA2EE;IACE,aAAA;IACA,eAAA;IACA,SAAA;EAzEJ;EA2EE;IACE,UAAA;IACA,kBAAA;IACA,aAAA;EAzEJ;EA0EI;IACE,cAAA;IACA,gBAAA;IACA,iCAAA;EAxEN;EA2EE;IACE,aAAA;EAzEJ;EA8EA;IACE,gBAAA;EA5EF;EA6EE;;IAEE,iBAAA;IACA,eAAA;IACA,eAAA;EA3EJ;EA6EE;IACE,eAAA;IACA,gBAAA;EA3EJ;EAiFE;IACE,aAAA;EA/EJ;EAgFI;IACE,eAAA;EA9EN;AACF;AAoFA;EAGM;IACE,2BAAA;IACA,gBAAA;EApFN;EAwFI;IACE,gBAAA;EAtFN;EA4FE;;IAEE,iBAAA;IACA,eAAA;IACA,eAAA;EA1FJ;AACF;AA+FA;EACE,sCAAA;EACA;;;;;IAKE,wBAAA;EA7FF;EAgGA;IACE,cAAA;IACA,6CAAA;EA9FF;EA+FE;IACE,yBAAA;IACA,gBAAA;IACA,iCAAA;EA7FJ;EA+FE;IACE,yBAAA;EA7FJ;EA+FE;;IAEE,yBAAA;IACA,WAAA;EA7FJ;EAiGA;IACE,eAAA;EA/FF;EAiGE;IACE,YAAA;IACA,WAAA;EA/FJ;EAiGI;IACE,OAAA;EA/FN;EAoGA;IACE,aAAA;EAlGF;EAoGE;IACE,aAAA;EAlGJ;AACF;AAsGA;EACE;IACE,uBAAA;EApGF;EAsGE;IACE,aAAA;IACA,yBAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;EApGJ;EAsGI;IACE,8BAAA;IACA,aAAA;EApGN;EAsGM;IACE,eAAA;EApGR;EAwGI;IACE,aAAA;IACA,mBAAA;IACA,eAAA;EAtGN;EAwGM;IACE,UAAA;IACA,kBAAA;IACA,cAAA;EAtGR;EAwGQ;IACE,cAAA;EAtGV;EAyGQ;IACE,cAAA;IACA,eAAA;EAvGV;AACF;AA8GA;EACE;IACE,iBAAA;EA5GF;EA8GE;IACE,aAAA;EA5GJ;EA8GI;IACE,8BAAA;IACA,YAAA;EA5GN;EA8GM;IACE,eAAA;EA5GR;EAiHM;IACE,eAAA;IACA,iBAAA;EA/GR;AACF;AAqHA;EACE,YAAA;EACA,aAAA;AAnHF;;AAqHA;EACE,mBAAA;AAlHF;;AAqHA,wEAAA;AAEA;EACE,gCAAA,EAAA,wCAAA;EACA,6BAAA;AAnHF;;AAqHA;EACE,YAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;AAlHF;;AAqHA,yCAAA;AAEA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AAnHF;;AAqHA;EAEE,aAAA;AAnHF;;AAqHA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAlHF;;AAoHA;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,2BAAA;EACA,UAAA;AAjHF;;AAmHA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AAhHF;;AAkHA;EACE,eAAA;EACA,WAAA;AA/GF;;AAiHA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AA9GF;;AAgHA;;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AA7GF;;AA+GA;;EAEE,sBAAA;EACA,eAAA;EACA,kBAAA;AA5GF;;AA8GA;EACE,2BAAA;AA3GF;AA4GE;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AA1GJ;AA2GI;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAzGN;AA0GM;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AAxGR;AA0GM;EAGE,WAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;AA1GR;;AA+GA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA5GF;;AA8GA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AA3GF;;AA6GA;EACE,8BAAA;EACA,kBAAA;AA1GF;;AA4GA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AAzGF;;AA4GA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAzGF;;AA2GA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAxGF;;AA0GA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EAEA,WAAA;EAEA,iBAAA;AAzGF;;AA2GA;EACE,gBAAA;EACA,iCAAA,EAAA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAxGF;;AA0GA;EACE,oBAAA,EAAA,+BAAA;AAvGF;;AAyGA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAtGF;;AAyGA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,QAAA;EACA,WAAA;AAtGF;;AAwGA;EACE,0BAAA;AArGF;;AAwGA;EACE;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EArGF;EAuGA;IACE,8BAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;EArGF;EAuGA;IACE,2BAAA;IACA,kBAAA;EArGF;EAuGA;IACE,8BAAA;IACA,2BAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,0BAAA;IACA,iCAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;EArGF;AACF;AAwGA;EACE,UAAA;EAEA,kBAAA;EACA,aAAA;EACA,gBAAA;AAvGF;AAwGE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAtGJ;AAwGE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,2BAAA;EACA,UAAA;AAtGJ;AAuGI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AArGN;AAuGI;EACE,2BAAA;AArGN;AAsGM;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AApGR;AAqGQ;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAnGV;AAoGU;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AAlGZ;AAoGU;EAGE,WAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;AApGZ;;AA2GA;EAEE,aAAA;AAzGF;;AA4GA;EACE,eAAA;EACA,WAAA;AAzGF;;AA2GA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,mCAAA;AAxGF;;AA0GA;;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AAvGF;;AAyGA;;EAEE,sBAAA;EACA,eAAA;EACA,kBAAA;AAtGF;;AAyGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAtGF;;AAwGA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AArGF;;AAuGA;EACE,8BAAA;EACA,kBAAA;AApGF;;AAsGA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AAnGF;;AAsGA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AAnGF;;AAqGA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAlGF;;AAoGA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EAEA,WAAA;EAEA,iBAAA;AAnGF;;AAqGA;EACE,gBAAA;EACA,iCAAA,EAAA,uBAAA;EACA,wBAAA;EACA,WAAA;EACA,oBAAA;AAlGF;AAmGE;EACE,oBAAA,EAAA,+BAAA;AAjGJ;;AAqGA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AAlGF;;AAqGA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,QAAA;EACA,WAAA;AAlGF;;AAoGA;EACE,0BAAA;AAjGF;;AAoGA;EACE;IACE,wBAAA;IACA,yBAAA;IACA,qBAAA;IACA,oBAAA;IACA,iBAAA;EAjGF;EAmGA;IACE,8BAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;EAjGF;EAmGA;IACE,2BAAA;IACA,kBAAA;EAjGF;EAmGA;IACE,8BAAA;IACA,2BAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,0BAAA;IACA,iCAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;EAjGF;EAmGA;IACE,WAAA;IACA,eAAA;IACA,yCAAA;IACA,sDAAA;IACA,kBAAA;IACA,WAAA;IACA,4BAAA;IACA,yBAAA;IACA,aAAA;EAjGF;EAmGA;IACE,SAAA;IACA,4BAAA;EAjGF;EAmGA;IACE,WAAA;IACA,SAAA;EAjGF;EAmGA;IACE,YAAA;EAjGF;EAmGA;IACE,WAAA;IACA,yCAAA;IACA,YAAA;EAjGF;EAmGA;IACE,aAAA;EAjGF;EAmGA;IACE,aAAA;EAjGF;EAmGA;IACE,2BAAA;EAjGF;EAmGA;IACE,aAAA;EAjGF;EAmGA;IACE,aAAA;EAjGF;EAsGE;IACE,uBAAA;IACA,WAAA;IACA,gBAAA;IACA,OAAA;EApGJ;EAsGI;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,kBAAA;EApGN;EAsGM;IACE,eAAA;EApGR;EAwGI;IACE,eAAA;IACA,gBAAA;EAtGN;AACF;AA0GA;EACE,eAAA;AAxGF;;AA2GA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAxGF;;AA2GA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;EACA,gBAAA;EACA,OAAA;AAxGF;;AA2GA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAxGF;;AA2GA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AAxGF;;AA4GA;EACE,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAzGF;AA2GE;EACE,YAAA;EACA,UAAA;AAzGJ;AA4GE;EACE,YAAA;EACA,UAAA;AA1GJ;;AA8GA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;AA3GF;;AA8GA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;AA3GF;;AA8GA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;AA3GF;;AA8GA;EACE,WAAA;EACA,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;AA3GF;;AA8GA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA3GF;;AA8GA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AA3GF;AA6GE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AA3GJ;AA6GI;EACE,YAAA;EACA,UAAA;AA3GN;AAgHI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AA9GN;AAiHI;EACE,aAAA;EACA,uBAAA;AA/GN;AAiHM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;AA/GR;AAoHE;EACE,aAAA;AAlHJ;AAoHI;EACE,OAAA;EACA,YAAA;AAlHN;;AAwHA;EACE;IACE,4BAAA;EArHF;EAuHA;IACE,2BAAA;EArHF;AACF;AAyHA;EACE;IACE,0BAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;IACA,iBAAA;EAvHF;EA0HA;IACE,aAAA;IACA,cAAA;IACA,WAAA;IACA,iBAAA;IACA,cAAA;EAxHF;EA2HA;IACE,aAAA;IACA,cAAA;IACA,WAAA;IACA,iBAAA;IACA,aAAA;EAzHF;AACF;AA4HA;EACE;IACE,YAAA;IACA,QAAA;IACA,iBAAA;EA1HF;EA6HA;;IAEE,YAAA;IACA,aAAA;EA3HF;EA8HA;IACE,iBAAA;EA5HF;EA+HA;IACE,iBAAA;EA7HF;AACF;AAgIA,mDAAA;AAEE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,SAAA;AA/HJ;AAiII;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA,EAAA,yBAAA;EACA,kBAAA,EAAA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AA/HN;AAiIM;EACE,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,2BAAA;AA/HR;AAkIM;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,QAAA;AAhIR;AAkIQ;EACE,kCAAA;EACA,2BAAA;AAhIV;AAiIU;EACE,eAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AA/HZ;AAmIQ;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAjIV;;AAwIA,oCAAA;AACA;EAEI;IACE,eAAA;IACH,gBAAA;IAEG,SAAA;EAvIJ;EAwII;IACE,mBAAA;IACA,eAAA;IACA,WAAA;IACA,gBAAA;IACA,OAAA;EAtIN;EA0IE;IACE,uBAAA,EAAA,iCAAA;EAxIJ;EAyII;IACE,aAAA;EAvIN;AACF;AAgJE;;;;;;;;;EASE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AA9IJ;AAiJE;EAAwB,yBAAA;AA9I1B;AA+IE;;EAEE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA7IJ;AAgJE;EACE,8BAAA;EACA,kDAAA;AA9IJ;AAiJE;EACE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA/IJ;AAiJE;EAAqB,kDAAA;AA9IvB;AA+IE;EAAwC,oCAAA;AA5I1C;AA6IE;EAA8B,oCAAA;EAAsC,yBAAA;AAzItE;AA2IE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAzIJ;AA2IE;EACE,8BAAA;EACA,oCAAA;EACA,yBAAA;EACA,kDAAA;AAzIJ;AA2IE;EAAiB,8BAAA;AAxInB;AA0IE;EACE,8BAAA;EACA,oCAAA;EACA,kDAAA;EACA,yBAAA;AAxIJ;AA0IE;EAAmC,kCAAA;AAvIrC;AAwIE;EAAqC,yBAAA;AArIvC;AAsIE;EAA8B,yBAAA;AAnIhC;AAqIE;EACE,yBAAA;AAnIJ;AAsIE;EACE,8BAAA;AApIJ;AAqII;EACE,8BAAA;EACA,kDAAA;AAnIN;AAoIM;EACE,iDAAA;AAlIR;AAmIQ;EAAwB,8BAAA;EAAgC,yBAAA;AA/HhE;AAkII;EAAc,8BAAA;EAAgC,yBAAA;EAA2B,kDAAA;AA7H7E;AAgIE;;;;EAIE,8BAAA;EACA,oCAAA;EACA,iDAAA;AA9HJ;AAiIE;;;;;EAKE,oFAAA;EACA,qCAAA;EACA,oDAAA;AA/HJ;;AAyIA;;EAEE,mCAAA;EACA,8BAAA;AAtIF;;AAyIA;;;;;;;;;;;;EAYE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAtIF;;AAyIA;;;;;EAKE,mCAAA;EACA,8BAAA;EACA,yCAAA;AAtIF;;AAyIA;EACE,wCAAA;EACA,8BAAA;EACA,yCAAA;AAtIF;;AAyIA;EACE,yCAAA;AAtIF;;AAyIA;;;EAGE,8BAAA;EACA,8BAAA;EACA,yCAAA;AAtIF;;AAyIA;EACE,mCAAA;EACA,8BAAA;AAtIF;;AAyIA;EACE,oCAAA;EACA,8BAAA;EACA,yCAAA;AAtIF;;AAyIA;EACE,qCAAA;EACA,6BAAA;AAtIF;;AAyIA;;;;;;;;;EASE,8BAAA;AAtIF;;AAyIA;EACE,8BAAA;AAtIF;;AAyIA,8EAAA;AAEA;EACE,oCAAA;EACA,iDAAA;EACA,8BAAA;AAvIF;;AA0IA;EACE,oCAAA;EACA,yCAAA;AAvIF;;AA0IA;EAAwC,yBAAA;AAtIxC;;AAwIA;;EAEE,8BAAA;EACA,yBAAA;EACA,iDAAA;AArIF;;AAwIA;EACE,mCAAA;EACA,yCAAA;AArIF;;AAwIA;EACE,wCAAA;EACA,8BAAA;EACA,yCAAA;AArIF;;AAwIA;EACE,yCAAA;AArIF;;AAwIA;EACE,oCAAA;AArIF;;AAwIA;EACE,+CAAA;EACA,8BAAA;AArIF;;AAwIA;EACE,kCAAA;AArIF;;AAwIA;EACE,yBAAA;AArIF;;AAwIA;EACE,yBAAA;AArIF;;AAwIA;;EAEE,oCAAA;EACA,yCAAA;AArIF;;AAwIA;;EAEE,oCAAA;AArIF;;AAwIA;EACE,6EAAA;EACA,yBAAA;EACA,gCAAA;AArIF;;AAwIA;EACE,iDAAA;AArIF;;AAwIA;EAAmD,8BAAA;AApInD;;AAqIA;EAA4D,yBAAA;AAjI5D;;AAkIA;EAA2D,yBAAA;AA9H3D;;AAgIA;EACE,oCAAA;EACA,yBAAA;EACA,yCAAA;AA7HF;;AA+HA,gDAAA;AACA;EACE,8BAAA;EACA,oCAAA;AA5HF;;AA8HA;;EAEE,mBAAA;EACA,UAAA;EACA,WAAA;AA3HF;;AA6HA;;EAEE,mBAAA;EACA,kBAAA;AA1HF;;AA4HA;;EAEE,mBAAA;EACA,kBAAA;AAzHF;;AA2HA;;EAEE,mBAAA;AAxHF;;AA0HA;;EAEE,mBAAA;AAvHF;;AA0HA,2CAAA;AACA;;EAEE,8BAAA;EACA,yBAAA;EACA,gDAAA;AAvHF;;AAyHA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAtHF;;AAwHA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AArHF;;AAuHA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AApHF;;AAuHA,oDAAA;AACA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AApHF;;AAsHA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAnHF;;AAqHA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAlHF;;AAoHA;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAjHF","sourcesContent":["/* Styles specific to OutgoingApprovalsComponent */\n\n.big-box {\n  border: 2px solid #333;\n  padding: 20px;\n  background-color: #f0f0f0;\n  border-radius: 10px;\n  box-shadow: 2px 2px 5px #888;\n  text-align: center;\n}\n\n/* Filters and actions styling for Transfered Content Approvals */\n.filter-section {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e6e6e6;\n  background: #f9fbfe;\n}\n\n.filter-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.filter-control label {\n  font-size: 13px;\n  color: #3c4858;\n  font-weight: 600;\n}\n\n.filter-control select,\n.filter-control input[type=\"date\"] {\n  height: 36px;\n  padding: 6px 10px;\n  border: 1px solid #cfd8dc;\n  border-radius: 6px;\n  background: #fff;\n  color: #263238;\n}\n\n.custom-date-range {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.actions-cell {\n  white-space: nowrap;\n\n  .btn,\n  .badge,\n  mat-icon {\n    vertical-align: middle;\n  }\n}\n\n.action-btn {\n  min-width: 88px;\n  margin-right: 8px;\n  border-radius: 6px;\n  text-transform: capitalize;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);\n}\n\n.action-btn--approve {\n  background-color: #2e7d32;\n  border-color: #2e7d32;\n}\n\n.action-btn--reject {\n  background-color: #c62828;\n  border-color: #c62828;\n}\n\n.action-btn--cancel {\n  background-color: #f9a825;\n  border-color: #f9a825;\n  color: #1a1a1a;\n}\n/* Make followers-tag cards look exactly like dashboard cards */\n.followers-tag {\n  display: flex;\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.followers-tag .box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  // min-width: 200px;\n  gap: 12px;\n}\n\n.followers-tag .box .icon {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.followers-tag .box .ico-box {\n  width: 40px;\n  height: 40px;\n  background: transparent; /* remove bg */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0;\n}\n\n.followers-tag .box .card-icon {\n  font-size: 24px;\n  color: #5ea1d8;\n}\n\n.followers-tag .box .text {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  flex: 1;\n  justify-content: center;\n  gap: 2px;\n}\n\n.followers-tag .box .text .count {\n  background: white !important;\n  box-shadow: none !important;\n}\n\n.followers-tag .box .text .count b {\n  font-size: 24px; /* increased for better prominence */\n  font-weight: 700 !important; /* bold like dashboard */\n  color: #333;\n  display: block;\n  line-height: 1.2;\n}\n\n.followers-tag .box .text p {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n  line-height: 1.2;\n  text-align: left;\n}\nbody {\n  overflow-x: hidden;\n}\n\n.logo {\n  width: 100px;\n  margin-right: 100px;\n}\n\n.top-menu-wrap {\n  display: flex;\n  align-items: center;\n  padding: 20px 10px;\n}\n\n.user-name {\n  display: flex;\n  align-items: center;\n}\n\n.user-details {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.user-name p {\n  display: flex;\n  align-items: center;\n}\n\n.user-name span {\n  width: 40px;\n  height: 40px;\n  background: red;\n  border-radius: 50%;\n  display: block;\n  margin-right: 10px;\n}\n\n.dashbored-wrap {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  background: var(--fc-bg, #fff);\n  /* background: red; */\n}\n\n.top-menu-wrap {\n  width: 100%;\n  height: 100px;\n\n  background: #fff;\n}\n\n.dash-details {\n  width: 100%;\n  display: flex;\n  max-height: 100vh;\n\n  /* background: green; */\n}\n\n.detail-list {\n  max-width: 250px;\n  width: 100%;\n  padding: 20px 10px;\n  background-color: #efeeee;\n  color: #212529;\n  position: fixed;\n  top: calc(var(--app-header) + 24px);\n  height: calc(100vh - 120px);\n}\n\nul {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\n\np {\n  margin-bottom: 10px;\n}\n\nul li {\n  margin-bottom: 10px;\n  height: 40px;\n\n  padding: 0px 10px;\n  position: relative;\n  z-index: 1;\n  color: #212529;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  transition: width 0.3s ease 0s, left 0.3s ease 0s;\n}\n\nul li:before {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 100%;\n  left: 0px;\n  position: absolute;\n  background: #fff;\n  transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  width: 0%;\n  z-index: -1;\n}\n\nul li:hover {\n  color: #000;\n}\n\nul li:hover:before {\n  /* background: #fff;\n      color: #212529; */\n  width: 100%;\n}\n\n.table-bordered {\n  border: 0px;\n}\n\n.detail-description {\n  /* width: 100%; */\n  height: 100%;\n  padding: 0px;\n  width: calc(100% - 250px);\n  height: 100%;\n  padding: 0px;\n  width: 100%;\n  // position: absolute;\n  left: 270px;\n  top: calc(var(--app-header) + 24px);\n  /* background: purple; */\n}\n\n.followers-tag {\n  display: flex;\n  position: relative;\n  z-index: 1;\n}\n\nh3 {\n  position: relative;\n  z-index: 3;\n  color: #fff;\n  font-weight: normal;\n}\n\n.com-record {\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 0;\n  padding: 20px 30px 30px;\n  box-shadow: none !important;\n  border: none !important;\n  .followers-tag {\n    .box {\n      .text {\n        p.number {\n          font-family: Arial !important;\n        }\n      }\n    }\n  }\n}\n\n.com-record:after {\n  content: \"\";\n  width: 100%;\n  height: 60%;\n  /* background: gray; */\n  top: 0px;\n  position: absolute;\n  left: 0px;\n  z-index: 0;\n  // background: #5ea1d8;\n}\n\n.ico-box {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  margin-bottom: 8px;\n}\n\n.ico-box b {\n  font-size: 18px;\n  font-weight: bold;\n  color: #333;\n  text-align: center;\n  line-height: 1;\n  display: block;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: \"Arial\", sans-serif;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.table-wrap {\n  padding: 30px;\n  /* width:calc(100% - 76px); */\n}\n\n.box {\n  width: auto;\n  padding: 15px 20px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  // min-width: 140px;\n  // min-height: 100px;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  box-shadow: none !important;\n  background-color: #fff !important;\n}\n\n.box:hover {\n  transform: translateY(-2px);\n  box-shadow: 2px 4px 30px rgba(0, 0, 0, 0.2);\n}\n\n.box:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, #5ea1d8, #4a90da);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.box:hover:before {\n  opacity: 1;\n}\n\n.filter-ico li {\n  width: 40px;\n}\n\n.filter-ico li i {\n  color: #000;\n}\n\n.text {\n  padding: 0;\n  text-align: center;\n  width: 100%;\n}\n\n.text p {\n  margin: 0;\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n  line-height: 1.2;\n  font-weight: 500;\n}\n\n.table-parent {\n  overflow-x: scroll;\n  margin-top: -8px;\n  // max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Scoped table styling */\n.table-card {\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(28, 28, 30, 0.06);\n  padding: 0;\n  margin-top: 5vh;\n}\n\n.fc-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.fc-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  text-align: left;\n  padding: 16px;\n  border-bottom: 2px solid #e0e0e0;\n  border-right: 1px solid #e0e0e0;\n}\n\n.fc-table thead th:first-child {\n  border-top-left-radius: 10px;\n}\n\n.fc-table thead th:last-child {\n  border-top-right-radius: 10px;\n  border-right: none;\n}\n\n.fc-table tbody tr {\n  transition: background-color 0.15s ease-in-out;\n}\n\n.fc-table tbody tr:nth-child(even) td {\n  background-color: #f7fbff;\n}\n\n.fc-table tbody tr:hover td {\n  background-color: #f0f8ff;\n  color: #2c3e50;\n  font-weight: 500;\n  border-color: #bbdefb;\n  transition: all 0.3s ease;\n}\n\n.fc-table tbody td {\n  padding: 12px 14px;\n  border-top: 1px solid #e6eef4;\n  border-right: 1px solid #eef3f7;\n}\n\n.fc-table tbody td:last-child {\n  border-right: none;\n}\n\n.fc-table tbody tr:last-child td:first-child {\n  border-bottom-left-radius: 10px;\n}\n\n.fc-table tbody tr:last-child td:last-child {\n  border-bottom-right-radius: 10px;\n}\n\ntable {\n  margin-bottom: 20px;\n  border-collapse: collapse;\n  width: 100%;\n  background: white;\n  border-radius: 0 0 8px 8px;\n  overflow: hidden;\n}\n\nth,\ntd {\n  border: none;\n  color: #333;\n  padding: 16px;\n  min-width: 100px;\n  font-family: \"Raleway\";\n  vertical-align: middle;\n}\n\nth {\n  background-color: #f5f5f5;\n  font-weight: 600;\n  color: #333;\n  text-transform: uppercase;\n  font-size: 12px;\n  letter-spacing: 0.5px;\n  padding: 16px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\ntd {\n  padding: 16px;\n  border-bottom: 1px solid #e0e0e0;\n  vertical-align: middle;\n}\n\ntd[scope=\"row\"] {\n  position: relative;\n}\n\n.inner {\n  width: 100%;\n  margin-bottom: 0px;\n\n  td {\n    padding: 5px;\n    border: 0px;\n\n    &:first-child {\n      width: 30px;\n    }\n  }\n}\n\ntbody tr {\n  cursor: pointer;\n  transition: background-color 0.2s;\n  &:hover {\n    background-color: #f9f9f9;\n    td {\n      color: #333;\n    }\n  }\n  &:last-child td {\n    border-bottom: none;\n  }\n}\n\n// tr:nth-child(even){\n//     background: #5ea1d8;\n\n// }\n// tr:nth-child(even) td{\n//     color: #fff;\n// }\n\n.filter {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0px;\n  border: 1px solid #ddd;\n  border-bottom: 0px;\n  padding: 10px 10px;\n}\n\n.filter-title {\n  flex: 1;\n}\n\n.filter ul {\n  display: flex;\n}\n\n.filter-bar {\n  display: flex;\n}\n\n.search-container {\n  position: relative;\n}\n\n.search-input {\n  width: 400px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  position: relative;\n}\n\n.search-input + i {\n  position: absolute;\n  right: 20px;\n  top: 37%;\n}\n\n.search-icon {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.chekbox-image {\n  display: flex;\n\n  td {\n    &:first-child {\n      width: unset;\n      flex: 1;\n      min-width: 150px;\n      display: flex;\n      align-items: flex-start;\n\n      span {\n        padding-left: 13px;\n      }\n    }\n\n    &:last-child {\n      min-width: unset;\n      width: 40px;\n      display: flex;\n      align-items: flex-start;\n    }\n  }\n}\n\n.image-sec {\n  img {\n    max-width: 100%;\n    max-height: 80px;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n\n.btn-add-page {\n  width: 75%;\n  display: block;\n  margin: 5px auto;\n}\n\n.square_btn {\n  text-align: center;\n  padding: 7px 20px;\n  border-radius: 25px;\n  border: 1px solid #5ea1d8;\n  text-decoration: none;\n  color: #5ea1d8;\n  background-image: -webkit-linear-gradient(45deg, white 0%, white 100%);\n  background-image: linear-gradient(45deg, white 0%, white 100%);\n\n  transition: 0.4s;\n  font-family: \"Raleway\";\n}\n\n.square_btn:hover {\n  color: white;\n  background-image: -webkit-linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n  background-image: linear-gradient(45deg, #5ea1d8 0%, #5ea1d8 100%);\n}\n\n.square_btn {\n  font-family: \"Raleway\";\n  color: #5ea1d8;\n  &:hover {\n    color: #fff;\n  }\n}\n\n.bundle-dialog {\n  min-width: 320px;\n  max-width: 420px;\n  padding: 8px 0;\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 20px;\n    border-bottom: 1px solid #e9ecef;\n    position: relative;\n\n    h2 {\n      margin: 0;\n      font-size: 18px;\n      font-weight: 600;\n      display: flex;\n      gap: 8px;\n      align-items: center;\n      color: #333;\n      flex: 1;\n      margin-left: 55px;\n      text-align: center;\n    }\n\n    .close-btn {\n      position: absolute;\n      right: 20px;\n      top: 50%;\n      transform: translateY(-50%);\n      background: none;\n      border: none;\n      cursor: pointer;\n      padding: 8px;\n      border-radius: 50%;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: #f0f0f0;\n      }\n    }\n\n    .close-icon {\n      font-size: 24px;\n      font-weight: bold;\n      color: #666;\n      line-height: 1;\n    }\n  }\n\n  .dialog-content {\n    padding: 16px 20px;\n\n    .subtitle {\n      margin: 0 0 12px 0;\n      color: #666;\n      font-size: 13px;\n    }\n  }\n}\n\n// Mobile Design Styles\n.mobile-design {\n  display: none;\n  padding: 20px 10px;\n  background: lightblue;\n\n  .tile {\n    background: #fff;\n    padding: 15px;\n    margin-bottom: 15px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    border: 1px solid #e9ecef;\n\n    .main-title {\n      display: flex;\n      align-items: center;\n      background: #5ea1d8;\n      padding: 12px;\n      margin: -15px -15px 15px -15px;\n      border-radius: 8px 8px 0 0;\n      cursor: pointer;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background: #4a8bc7;\n      }\n\n      h3 {\n        margin: 0;\n        color: #fff !important;\n        font-size: 16px;\n        font-weight: 600;\n      }\n    }\n\n    .first-tile {\n      margin-bottom: 15px;\n\n      .content-info {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 10px;\n\n        .content-type {\n          display: flex;\n          align-items: center;\n          color: #666;\n          font-size: 14px;\n\n          mat-icon {\n            font-size: 18px;\n            margin-right: 5px;\n            color: #5ea1d8;\n          }\n        }\n\n        .status-badge {\n          padding: 4px 8px;\n          border-radius: 12px;\n          font-size: 12px;\n          font-weight: 500;\n          text-transform: uppercase;\n          letter-spacing: 0.5px;\n\n          &.status-pending {\n            background: #fff3cd;\n            color: #856404;\n            border: 1px solid #ffeaa7;\n          }\n\n          &.status-approved {\n            background: #d4edda;\n            color: #155724;\n            border: 1px solid #c3e6cb;\n          }\n\n          &.status-rejected {\n            background: #f8d7da;\n            color: #721c24;\n            border: 1px solid #f5c6cb;\n          }\n\n          &.status-reworkrequested {\n            background: #fff3cd;\n            color: #856404;\n            border: 1px solid #ffeaa7;\n          }\n\n          &.status-cancelled {\n            background: #e2e3e5;\n            color: #383d41;\n            border: 1px solid #d6d8db;\n          }\n        }\n      }\n    }\n\n    .common-tile {\n      display: flex;\n      margin-bottom: 12px;\n\n      .title-tile {\n        flex: 1;\n        padding: 8px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        p {\n          margin: 0;\n          color: #666;\n          font-size: 12px;\n          line-height: 1.3;\n\n          &.bold {\n            font-weight: 600;\n            color: #333;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n\n    .actions-section {\n      border-top: 1px solid #e9ecef;\n      padding-top: 15px;\n      margin-top: 15px;\n\n      .processing-indicator {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 10px;\n        padding: 8px;\n        background: #f8f9fa;\n        border-radius: 6px;\n        font-size: 12px;\n        color: #666;\n\n        mat-spinner {\n          margin-right: 8px;\n        }\n      }\n\n      .mobile-btn {\n        width: 100%;\n        margin-bottom: 8px;\n        padding: 8px 12px;\n        font-size: 13px;\n        border-radius: 6px;\n        border: none;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        &:hover {\n          transform: translateY(-1px);\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        }\n      }\n\n      .badge {\n        display: inline-block;\n        padding: 6px 10px;\n        border-radius: 12px;\n        font-size: 11px;\n        font-weight: 500;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        text-align: center;\n        width: 100%;\n        margin-bottom: 8px;\n\n        &.badge-success {\n          background: #d4edda;\n          color: #155724;\n          border: 1px solid #c3e6cb;\n        }\n\n        &.badge-danger {\n          background: #f8d7da;\n          color: #721c24;\n          border: 1px solid #f5c6cb;\n        }\n\n        &.badge-secondary {\n          background: #e2e3e5;\n          color: #383d41;\n          border: 1px solid #d6d8db;\n        }\n\n        &.badge-info {\n          background: #d1ecf1;\n          color: #0c5460;\n          border: 1px solid #bee5eb;\n        }\n      }\n    }\n  }\n\n  .no-results {\n    text-align: center;\n    padding: 40px 20px;\n    color: #666;\n    font-size: 16px;\n    background: #fff;\n    border-radius: 8px;\n    border: 1px solid #e9ecef;\n  }\n}\n\n// Tablet-specific styles (768px - 1023px)\n@media (min-width: 768px) and (max-width: 1023px) {\n  .dashbored-wrap {\n    .detail-list {\n      display: none;\n    }\n    .detail-description {\n      width: 100%;\n      left: 0px;\n    }\n    .followers-tag {\n      flex-wrap: wrap;\n      width: 100%;\n      .box {\n        margin: 0;\n        width: calc(50% - 10px);\n        min-width: 250px;\n        .text {\n          flex: 1;\n        }\n      }\n    }\n    .com-record {\n      padding: 20px;\n      &:after {\n        height: 140px;\n      }\n    }\n    .filter {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n    }\n    .search-container {\n      .search-input {\n        width: 100%;\n        max-width: 400px;\n      }\n    }\n    .top-menu-wrap {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n    }\n    .table-wrap {\n      top: unset;\n      position: relative;\n      padding: 20px;\n      .table-parent {\n        display: block;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n      }\n    }\n    .mobile-design {\n      display: none;\n    }\n  }\n\n  // Tablet table optimizations\n  table {\n    min-width: 600px;\n    th,\n    td {\n      padding: 12px 8px;\n      font-size: 14px;\n      min-width: 80px;\n    }\n    th {\n      font-size: 13px;\n      font-weight: 600;\n    }\n  }\n\n  // Tablet stats cards\n  .followers-tag {\n    .box {\n      padding: 15px;\n      .text {\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n// Large tablets and small laptops (1024px - 1199px)\n@media (min-width: 1024px) and (max-width: 1199px) {\n  .dashbored-wrap {\n    .followers-tag {\n      .box {\n        width: calc(33.333% - 14px);\n        min-width: 200px;\n      }\n    }\n    .table-wrap {\n      .table-parent {\n        overflow-x: auto;\n      }\n    }\n  }\n\n  table {\n    th,\n    td {\n      padding: 10px 6px;\n      font-size: 13px;\n      min-width: 70px;\n    }\n  }\n}\n\n// Responsive Design\n@media (max-width: 992px) {\n  /* Hide all table elements on mobile */\n  .table-wrap,\n  .table-parent,\n  .table-card,\n  .fc-table,\n  table {\n    display: none !important;\n  }\n\n  .mobile-design {\n    display: block;\n    /* Re-enable table UI inside mobile section */\n    .table-parent {\n      display: block !important;\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n    .table-card {\n      display: block !important;\n    }\n    .fc-table,\n    table {\n      display: table !important;\n      width: 100%;\n    }\n  }\n\n  .followers-tag {\n    flex-wrap: wrap;\n\n    .box {\n      margin: 10px;\n      width: 100%;\n\n      .text {\n        flex: 1;\n      }\n    }\n  }\n\n  .com-record {\n    padding: 15px;\n\n    &:after {\n      height: 130px;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .mobile-design {\n    padding: 5px !important;\n\n    .tile {\n      padding: 12px;\n      border: 1px solid #e0e0e0;\n      border-radius: 8px;\n      background: #ffffff;\n      margin-bottom: 12px;\n\n      .main-title {\n        margin: -12px -12px 12px -12px;\n        padding: 10px;\n\n        h3 {\n          font-size: 15px;\n        }\n      }\n\n      .common-tile {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n\n        .title-tile {\n          width: 50%;\n          margin-bottom: 8px;\n          display: block;\n\n          p {\n            display: block;\n          }\n\n          .bold {\n            display: block;\n            margin-top: 2px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .mobile-design {\n    padding: 10px 5px;\n\n    .tile {\n      padding: 10px;\n\n      .main-title {\n        margin: -10px -10px 10px -10px;\n        padding: 8px;\n\n        h3 {\n          font-size: 14px;\n        }\n      }\n\n      .actions-section {\n        .mobile-btn {\n          font-size: 12px;\n          padding: 6px 10px;\n        }\n      }\n    }\n  }\n}\n\n.pie-chart-canvas {\n  width: 400px;\n  height: 400px;\n}\n.mat-mdc-tab-list {\n  margin-bottom: 10px;\n}\n\n/* Assuming each chart component has a class name of 'chart-container' */\n\n.row {\n  grid-template-columns: auto auto; /* Use flexbox to align items in a row */\n  overflow-x: hidden !important;\n}\n.chart-container {\n  margin: 15px;\n  height: 25vh;\n  width: 50vh;\n  flex: 1;\n}\n\n/* new setting common design starts here*/\n\n.setting-dashboard {\n  padding: 0;\n  height: auto;\n  position: relative;\n  margin-top: 0;\n  background: var(--fc-bg, #fff);\n}\n.dashbored-wrap {\n  // padding-left: 10px;\n  margin-top: 0;\n}\n.setting-dashboard .row {\n  flex-direction: row;\n  height: 100%;\n  margin: 0px;\n}\n.setting-dashboard .left-user {\n  background: #5ea1d8;\n  position: relative;\n  padding: 0 0 0 30px;\n  position: fixed;\n  top: 120px;\n  height: calc(100vh - 100px);\n  z-index: 3;\n}\n.collapse-btn {\n  position: absolute;\n  width: 25px;\n  height: 25px;\n  background: #5ea1d8;\n  border-radius: 50%;\n  right: -12.5px;\n  top: 26px;\n  border: 2px solid #fff;\n  box-shadow: 0 0 3px #171717;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  transform: rotate(180deg);\n}\n.setting-dashboard .left-user .dash-title {\n  position: unset;\n  width: 100%;\n}\n.setting-dashboard .dash-title {\n  height: 80px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: #fff;\n  position: fixed;\n  z-index: 2;\n  top: 120px;\n}\n.setting-dashboard .dash-title h6,\n.setting-dashboard .dash-title .h6 {\n  display: flex;\n  align-items: center;\n  font-weight: 500 !important;\n  color: #fff !important;\n}\n.setting-dashboard .dash-title h6 span,\n.setting-dashboard .dash-title .h6 span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n.setting-dashboard.search-add .dash-elemenet {\n  height: calc(100vh - 180px);\n  ul {\n    padding: 0px;\n    margin: 0px;\n    width: 100%;\n    list-style-type: none;\n    li {\n      height: 40px;\n      margin-bottom: 10px;\n      position: relative;\n      display: flex;\n      align-items: center;\n      transition: all 0.5s linear;\n      padding-left: 10px;\n      &:after {\n        bottom: 0;\n        content: \"\";\n        display: block;\n        height: 1px;\n        height: 100%;\n        left: 0%;\n        position: absolute;\n        background: #fff;\n        background: #1d67a3;\n        transition: all 0.5s linear;\n        width: 0;\n        z-index: -1;\n      }\n      &:hover:after,\n      &:active:after,\n      &:focus:after {\n        content: \"\";\n        width: 100%;\n        left: 0;\n        transition: all 0.5s linear;\n      }\n    }\n  }\n}\n.setting-dashboard .dash-elemenet {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-top: 1rem;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 20px;\n}\n.setting-dashboard .dash-elemenet > div {\n  width: 100%;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.5slinear;\n  position: relative;\n  padding-bottom: 0;\n  z-index: 2;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n.left-user .selected-item {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n.setting-dashboard .left-user .dash-elemenet > div span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n/*right section*/\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  // border-left: 1px solid #fff;\n  color: #fff;\n  // left: 16.666667%;\n  width: 83.333333%;\n}\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important; /* match landing page */\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n}\n.scroll-div .dash-text {\n  padding: 10px 15px 0; /* match landing page padding */\n}\n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n\n.setting-dashboard .dash-elemenet > div:after {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 1px;\n  height: 100%;\n  left: 0%;\n  position: absolute;\n  background: #fff;\n  background: #6322b2;\n  transition: width 0.5sease 0s, left 0.5sease 0s;\n  width: 0;\n  z-index: -1;\n}\n.setting-dashboard .dash-elemenet > div span:last-child {\n  font-size: 12px !important;\n}\n\n@media (max-width: 767px) {\n  .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n  .mob-menu {\n    background: #5d9fd5 !important;\n    position: sticky;\n    top: var(--app-header, 56px);\n    z-index: 1500;\n    width: 100%;\n    display: block !important;\n  }\n  .navbar {\n    justify-content: flex-start;\n    margin-bottom: 0px;\n  }\n  .mob-menu button {\n    background: #5d9fd5 !important;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 14px;\n    padding: 10px 5px;\n    text-transform: capitalize;\n    border: 1px solid #fff !important;\n    box-shadow: none !important;\n    display: flex !important;\n    align-items: center;\n  }\n}\n\n.setting-dashboard {\n  padding: 0;\n  // height: 100vh;\n  position: relative;\n  margin-top: 0;\n  background: #fff;\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n  .left-user {\n    background: #5ea1d8;\n    position: relative;\n    padding: 0 0 0 30px;\n    position: fixed;\n    top: calc(var(--app-header) + 24px);\n    height: calc(100vh - 100px);\n    z-index: 3;\n    .collapse-btn {\n      position: absolute;\n      width: 25px;\n      height: 25px;\n      background: #5ea1d8;\n      border-radius: 50%;\n      right: -12.5px;\n      top: 26px;\n      border: 2px solid #fff;\n      box-shadow: 0 0 3px #171717;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #fff;\n      transform: rotate(180deg);\n    }\n    .dash-elemenet {\n      height: calc(100vh - 180px);\n      ul {\n        padding: 0px;\n        margin: 0px;\n        width: 100%;\n        list-style-type: none;\n        li {\n          height: 40px;\n          margin-bottom: 10px;\n          position: relative;\n          display: flex;\n          align-items: center;\n          transition: all 0.5s linear;\n          padding-left: 10px;\n          &:after {\n            bottom: 0;\n            content: \"\";\n            display: block;\n            height: 1px;\n            height: 100%;\n            left: 0%;\n            position: absolute;\n            background: #fff;\n            background: #1d67a3;\n            transition: all 0.5s linear;\n            width: 0;\n            z-index: -1;\n          }\n          &:hover:after,\n          &:active:after,\n          &:focus:after {\n            content: \"\";\n            width: 100%;\n            left: 0;\n            transition: all 0.5s linear;\n          }\n        }\n      }\n    }\n  }\n}\n.dashbored-wrap {\n  // padding-left: 10px;\n  margin-top: 0;\n}\n\n.setting-dashboard .left-user .dash-title {\n  position: unset;\n  width: 100%;\n}\n.setting-dashboard .dash-title {\n  height: 80px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: #fff;\n  position: fixed;\n  z-index: 2;\n  top: calc(var(--app-header) + 24px);\n}\n.setting-dashboard .dash-title h6,\n.setting-dashboard .dash-title .h6 {\n  display: flex;\n  align-items: center;\n  font-weight: 500 !important;\n  color: #fff !important;\n}\n.setting-dashboard .dash-title h6 span,\n.setting-dashboard .dash-title .h6 span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.setting-dashboard .dash-elemenet {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-top: 1rem;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 20px;\n}\n.setting-dashboard .dash-elemenet > div {\n  width: 100%;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.5slinear;\n  position: relative;\n  padding-bottom: 0;\n  z-index: 2;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n.left-user .selected-item {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n.setting-dashboard .left-user .dash-elemenet > div span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n/*right section*/\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  // border-left: 1px solid #fff;\n  color: #fff;\n  // left: 16.666667%;\n  width: 83.333333%;\n}\n.scroll-div {\n  position: sticky;\n  top: var(--app-header) !important; /* match landing page */\n  margin-top: 0 !important;\n  width: 100%;\n  padding-bottom: 20px;\n  .dash-text {\n    padding: 10px 15px 0; /* match landing page padding */\n  }\n}\n\n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n\n.setting-dashboard .dash-elemenet > div:after {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 1px;\n  height: 100%;\n  left: 0%;\n  position: absolute;\n  background: #fff;\n  background: #6322b2;\n  transition: width 0.5sease 0s, left 0.5sease 0s;\n  width: 0;\n  z-index: -1;\n}\n.setting-dashboard .dash-elemenet > div span:last-child {\n  font-size: 12px !important;\n}\n\n@media (max-width: 767px) {\n  .scroll-div {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    top: 0 !important;\n  }\n  .mob-menu {\n    background: #5d9fd5 !important;\n    position: sticky;\n    top: var(--app-header, 56px);\n    z-index: 1500;\n    width: 100%;\n    display: block !important;\n  }\n  .navbar {\n    justify-content: flex-start;\n    margin-bottom: 0px;\n  }\n  .mob-menu button {\n    background: #5d9fd5 !important;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 14px;\n    padding: 10px 5px;\n    text-transform: capitalize;\n    border: 1px solid #fff !important;\n    box-shadow: none !important;\n    display: flex !important;\n    align-items: center;\n  }\n  .setting-dashboard .left-user {\n    width: 59vw;\n    position: fixed;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: calc(100vh - (var(--app-header, 56px) + 48px));\n    padding-left: 10px;\n    left: -59vw;\n    transition: left 0.5s linear;\n    display: block !important;\n    z-index: 1600;\n  }\n  .setting-dashboard .show-menu .left-user {\n    left: 0px;\n    transition: left 0.5s linear;\n  }\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0px;\n  }\n  .dashbored-wrap .table-wrap {\n    padding: 0px;\n  }\n  .setting-dashboard .submission-field .hamburger .dash-title {\n    width: 100%;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: 40px;\n  }\n  .setting-dashboard .left-user .dash-title {\n    display: none;\n  }\n  .setting-dashboard .left-user .collapse-btn {\n    display: none;\n  }\n  .dashbored-wrap {\n    margin-top: 17px !important;\n  }\n  .dashbored-wrap .mobile-design {\n    padding: 20px;\n  }\n  .dashbored-wrap .com-record:after {\n    height: 133px;\n  }\n\n  // Mobile-specific styling for dashboard boxes\n  .followers-tag {\n    .box {\n      margin: 0px 0px 8px 0px;\n      width: 100%;\n      min-width: 200px;\n      flex: 1;\n\n      .ico-box {\n        width: 35px;\n        height: 35px;\n        margin-bottom: 6px;\n        border-radius: 6px;\n\n        b {\n          font-size: 16px;\n        }\n      }\n\n      .text p {\n        font-size: 11px;\n        line-height: 1.1;\n      }\n    }\n  }\n}\n.cursor {\n  cursor: pointer;\n}\n// Skeleton Loader Styles\n.skeleton-stats-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.skeleton-box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  min-width: 150px;\n  flex: 1;\n}\n\n.skeleton-table-container {\n  margin: 16px 0;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  width: 100%;\n  min-height: 300px;\n  overflow-x: auto;\n}\n\n.skeleton-mobile-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin: 16px 0;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  width: 100%;\n  min-height: 400px;\n}\n\n// Skeleton element styles\n.skeleton-text {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  height: 16px;\n  margin: 4px 0;\n\n  &.skeleton-title {\n    height: 20px;\n    width: 80%;\n  }\n\n  &.skeleton-bold {\n    height: 18px;\n    width: 60%;\n  }\n}\n\n.skeleton-checkbox {\n  width: 20px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 3px;\n  margin-right: 10px;\n}\n\n.skeleton-icon {\n  width: 20px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 50%;\n}\n\n.skeleton-image {\n  width: 100%;\n  height: 80px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  object-fit: cover;\n}\n\n.skeleton-price {\n  width: 60px;\n  height: 20px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite;\n  border-radius: 4px;\n  margin-left: 10px;\n}\n\n.skeleton-analytics {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.skeleton-tile {\n  background: #fff;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  width: 100%;\n\n  .main-title {\n    display: flex;\n    align-items: center;\n    background: #5ea1d8;\n    padding: 10px;\n    margin-bottom: 10px;\n\n    .skeleton-title {\n      height: 24px;\n      width: 70%;\n    }\n  }\n\n  .first-tile {\n    div {\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n    }\n\n    .img {\n      display: flex;\n      align-items: flex-start;\n\n      .bundle {\n        width: 30px;\n        margin-right: 10px;\n        height: 30px;\n      }\n    }\n  }\n\n  .common-tile {\n    display: flex;\n\n    .title-tile {\n      flex: 1;\n      padding: 3px;\n    }\n  }\n}\n\n// Skeleton loading animation\n@keyframes skeleton-loading {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n// Mobile responsiveness for skeleton containers\n@media (max-width: 768px) {\n  .skeleton-stats-container {\n    grid-template-columns: 1fr;\n    gap: 12px;\n    padding: 12px;\n    width: 100%;\n    min-height: 150px;\n  }\n\n  .skeleton-table-container {\n    padding: 12px;\n    margin: 12px 0;\n    width: 100%;\n    min-height: 250px;\n    display: block;\n  }\n\n  .skeleton-mobile-container {\n    padding: 12px;\n    margin: 12px 0;\n    width: 100%;\n    min-height: 300px;\n    display: flex;\n  }\n}\n\n@media (max-width: 480px) {\n  .skeleton-stats-container {\n    padding: 8px;\n    gap: 8px;\n    min-height: 120px;\n  }\n\n  .skeleton-table-container,\n  .skeleton-mobile-container {\n    padding: 8px;\n    margin: 8px 0;\n  }\n\n  .skeleton-table-container {\n    min-height: 200px;\n  }\n\n  .skeleton-mobile-container {\n    min-height: 250px;\n  }\n}\n\n/* Desktop followers-tag cards to match dashboard */\n.dashbored-wrap {\n  .followers-tag {\n    display: flex;\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    flex-wrap: wrap;\n    gap: 16px;\n\n    .box {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      gap: 12px;\n      box-shadow: none;\n      background-color: #fff;\n      width: auto;\n      padding: 5px 10px; /* desktop card padding */\n      margin-right: 20px; /* desktop spacing */\n      border: 1px solid #ddd;\n      border-radius: 10px;\n      min-width: 200px;\n\n      .ico-box {\n        background: transparent;\n        border-radius: 0;\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: none !important;\n        box-shadow: none !important;\n      }\n\n      .text {\n        display: flex;\n        flex-direction: column;\n        text-align: left;\n        flex: 1;\n        justify-content: center;\n        gap: 2px;\n\n        .count {\n          background: transparent !important;\n          box-shadow: none !important;\n          b {\n            font-size: 24px;\n            font-weight: 700 !important;\n            color: #333;\n            display: block;\n            line-height: 1.2;\n          }\n        }\n\n        p {\n          margin: 0;\n          font-size: 14px;\n          color: #666;\n          line-height: 1.2;\n        }\n      }\n    }\n  }\n}\n\n/* Mobile: match dashboard spacing */\n@media (max-width: 992px) {\n  .dashbored-wrap {\n    .followers-tag {\n      flex-wrap: wrap;\n   margin-top: 10px;\n\n      gap: 16px;\n      .box {\n        margin-bottom: -8px;\n        margin-right: 0;\n        width: 100%;\n        min-width: 200px;\n        flex: 1;\n        // padding: 12px 15px; /* mobile card padding */\n      }\n    }\n    .com-record {\n      padding: 7px !important; /* consistent container padding */\n      &:after {\n        height: 130px;\n      }\n    }\n  }\n}\n\n// ==============================================\n// DARK MODE\n// ==============================================\n:host-context(body.theme-dark) {\n  .dashbored-wrap,\n  .setting-dashboard,\n  .scroll-div,\n  .com-record,\n  .table-wrap,\n  .filter,\n  .filter-section,\n  .search-input,\n  .detail-list {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  .filter-control label { color: #94a3b8 !important; }\n  .filter-control select,\n  .filter-control input[type=\"date\"] {\n    background: #0f172a !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .table-card {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  .fc-table thead th {\n    background: #0f172a !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  .fc-table tbody td { border-color: rgba(148, 163, 184, 0.15) !important; }\n  .fc-table tbody tr:nth-child(even) td { background-color: #1a2030 !important; }\n  .fc-table tbody tr:hover td { background-color: #1f2937 !important; color: #e5e7eb !important; }\n\n  table, thead, tbody, tr, td {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #e5e7eb !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  th {\n    background: #0f172a !important;\n    background-color: #0f172a !important;\n    color: #94a3b8 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n  }\n  tbody tr:hover { background: #1f2937 !important; }\n\n  .box, .followers-tag .box {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.25) !important;\n    color: #e5e7eb !important;\n  }\n  .followers-tag .box .text .count { background: transparent !important; }\n  .followers-tag .box .text .count b { color: #f1f5f9 !important; }\n  .followers-tag .box .text p { color: #94a3b8 !important; }\n\n  p, span:not(.material-icons):not(.status-badge-modern):not([class*=\"badge\"]):not([class*=\"status-\"]), label, li, h1, h2, h3, h4, h5, h6, i, b {\n    color: #e5e7eb !important;\n  }\n\n  .mobile-design {\n    background: #0f172a !important;\n    .tile {\n      background: #1f2937 !important;\n      border-color: rgba(148, 163, 184, 0.25) !important;\n      .actions-section {\n        border-color: rgba(148, 163, 184, 0.2) !important;\n        .processing-indicator { background: #0f172a !important; color: #94a3b8 !important; }\n      }\n    }\n    .no-results { background: #1f2937 !important; color: #94a3b8 !important; border-color: rgba(148, 163, 184, 0.25) !important; }\n  }\n\n  .skeleton-box,\n  .skeleton-tile,\n  .skeleton-table-container,\n  .skeleton-mobile-container {\n    background: #1f2937 !important;\n    background-color: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .skeleton-text,\n  .skeleton-checkbox,\n  .skeleton-icon,\n  .skeleton-image,\n  .skeleton-price {\n    background: linear-gradient(90deg, #1f2937 25%, #374151 50%, #1f2937 75%) !important;\n    background-size: 200% 100% !important;\n    animation: skeleton-loading 1.5s infinite !important;\n  }\n}\n\n\n// ════════════════════════════════════════════════\n// DARK MODE – direct body.theme-dark rules\n// These compile to body.theme-dark .class[_ngcontent-xxx]\n// which reliably overrides all hardcoded whites.\n// ════════════════════════════════════════════════\nbody.theme-dark .dashbored-wrap,\nbody.theme-dark .setting-dashboard {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .top-menu-wrap,\nbody.theme-dark .dashbored-wrap .box,\nbody.theme-dark .dashbored-wrap .card,\nbody.theme-dark .dashbored-wrap .mat-mdc-card,\nbody.theme-dark .dashbored-wrap .tile,\nbody.theme-dark .dashbored-wrap .com-record,\nbody.theme-dark .dashbored-wrap .table-wrap,\nbody.theme-dark .dashbored-wrap .detail-list,\nbody.theme-dark .dashbored-wrap .filter,\nbody.theme-dark .dashbored-wrap .search-input,\nbody.theme-dark .dashbored-wrap .tab-content,\nbody.theme-dark .dashbored-wrap .followers-tag .box {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap table,\nbody.theme-dark .dashbored-wrap thead,\nbody.theme-dark .dashbored-wrap tbody,\nbody.theme-dark .dashbored-wrap tr,\nbody.theme-dark .dashbored-wrap td {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap th {\n  background: var(--fc-bg-head) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap tbody tr:hover {\n  background: var(--fc-bg-hover) !important;\n}\n\nbody.theme-dark .dashbored-wrap input,\nbody.theme-dark .dashbored-wrap select,\nbody.theme-dark .dashbored-wrap textarea {\n  background: #0f172a !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design {\n  background: var(--fc-bg) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap .mobile-design .tile {\n  background: var(--fc-bg2) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .dashbored-wrap [class*=\"skeleton-\"] {\n  background: var(--fc-skel) !important;\n  color: transparent !important;\n}\n\nbody.theme-dark .dashbored-wrap p,\nbody.theme-dark .dashbored-wrap label,\nbody.theme-dark .dashbored-wrap li,\nbody.theme-dark .dashbored-wrap h1,\nbody.theme-dark .dashbored-wrap h2,\nbody.theme-dark .dashbored-wrap h3,\nbody.theme-dark .dashbored-wrap h4,\nbody.theme-dark .dashbored-wrap h5,\nbody.theme-dark .dashbored-wrap h6 {\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .dashbored-wrap span:not(.material-icons):not(.badge):not([class*=\"status\"]) {\n  color: var(--fc-fg) !important;\n}\n\n/* ── Direct body.theme-dark additions (outgoing-transfer-approvals page) ── */\n\nbody.theme-dark .big-box {\n  background-color: #1f2937 !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .filter-section {\n  background: var(--fc-bg2) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .filter-control label { color: #94a3b8 !important; }\n\nbody.theme-dark .filter-control select,\nbody.theme-dark .filter-control input[type=\"date\"] {\n  background: #0f172a !important;\n  color: #e5e7eb !important;\n  border-color: rgba(148, 163, 184, 0.3) !important;\n}\n\nbody.theme-dark .table-card {\n  background: var(--fc-bg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .fc-table thead th {\n  background: var(--fc-bg-head) !important;\n  color: var(--fc-fg) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .fc-table tbody td {\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .fc-table tbody tr:nth-child(even) td {\n  background-color: #1a2030 !important;\n}\n\nbody.theme-dark .fc-table tbody tr:hover td {\n  background-color: var(--fc-bg-hover) !important;\n  color: var(--fc-fg) !important;\n}\n\nbody.theme-dark .followers-tag .box .text .count {\n  background: transparent !important;\n}\n\nbody.theme-dark .followers-tag .box .text .count b {\n  color: #f1f5f9 !important;\n}\n\nbody.theme-dark .followers-tag .box .text p {\n  color: #94a3b8 !important;\n}\n\nbody.theme-dark .skeleton-box,\nbody.theme-dark .skeleton-tile {\n  background: var(--fc-bg2) !important;\n  border-color: var(--fc-border) !important;\n}\n\nbody.theme-dark .skeleton-table-container,\nbody.theme-dark .skeleton-mobile-container {\n  background: var(--fc-bg2) !important;\n}\n\nbody.theme-dark .square_btn {\n  background-image: linear-gradient(45deg, #1f2937 0%, #1f2937 100%) !important;\n  color: #5ea1d8 !important;\n  border-color: #5ea1d8 !important;\n}\n\nbody.theme-dark .bundle-dialog .dialog-header {\n  border-color: rgba(148, 163, 184, 0.2) !important;\n}\n\nbody.theme-dark .bundle-dialog .dialog-header h2 { color: var(--fc-fg) !important; }\nbody.theme-dark .bundle-dialog .dialog-header .close-icon { color: #94a3b8 !important; }\nbody.theme-dark .bundle-dialog .dialog-content .subtitle { color: #94a3b8 !important; }\n\nbody.theme-dark .no-results {\n  background: var(--fc-bg2) !important;\n  color: #94a3b8 !important;\n  border-color: var(--fc-border) !important;\n}\n/* ── Dark scrollbars and overflow area fix ── */\nbody.theme-dark .table-parent {\n  background: #1f2937 !important;\n  background-color: #1f2937 !important;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar,\nbody.theme-dark .table-card::-webkit-scrollbar {\n  background: #111827;\n  width: 6px;\n  height: 6px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-track,\nbody.theme-dark .table-card::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 4px;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-thumb:hover,\nbody.theme-dark .table-card::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\nbody.theme-dark .table-parent::-webkit-scrollbar-corner,\nbody.theme-dark .table-card::-webkit-scrollbar-corner {\n  background: #111827;\n}\n\n/* ── Status badge dark mode overrides ── */\nbody.theme-dark .status-badge.status-pending,\nbody.theme-dark .status-badge.status-reworkrequested {\n  background: #451a03 !important;\n  color: #fcd34d !important;\n  border-color: rgba(252, 211, 77, 0.3) !important;\n}\nbody.theme-dark .status-badge.status-approved {\n  background: #052e16 !important;\n  color: #86efac !important;\n  border-color: rgba(134, 239, 172, 0.3) !important;\n}\nbody.theme-dark .status-badge.status-rejected {\n  background: #450a0a !important;\n  color: #fca5a5 !important;\n  border-color: rgba(252, 165, 165, 0.3) !important;\n}\nbody.theme-dark .status-badge.status-cancelled {\n  background: #1f2937 !important;\n  color: #9ca3af !important;\n  border-color: rgba(156, 163, 175, 0.3) !important;\n}\n\n/* ── Bootstrap-style badge dark mode overrides ── */\nbody.theme-dark .badge.badge-success {\n  background: #052e16 !important;\n  color: #86efac !important;\n  border-color: rgba(134, 239, 172, 0.3) !important;\n}\nbody.theme-dark .badge.badge-danger {\n  background: #450a0a !important;\n  color: #fca5a5 !important;\n  border-color: rgba(252, 165, 165, 0.3) !important;\n}\nbody.theme-dark .badge.badge-secondary {\n  background: #1f2937 !important;\n  color: #9ca3af !important;\n  border-color: rgba(156, 163, 175, 0.3) !important;\n}\nbody.theme-dark .badge.badge-info {\n  background: #0c3443 !important;\n  color: #67e8f9 !important;\n  border-color: rgba(103, 232, 249, 0.3) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
